/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 2015-05-07.2
 *
 * By Eli Grey, http://eligrey.com
 * License: X11/MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
        "use strict";
        // IE <10 is explicitly unsupported
        if (typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
            return;
        }
        var
            doc = view.document
        // only get URL when necessary in case Blob.js hasn't overridden it yet
            , get_URL = function() {
                return view.URL || view.webkitURL || view;
            }
            , save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
            , can_use_save_link = "download" in save_link
            , click = function(node) {
                var event = doc.createEvent("MouseEvents");
                event.initMouseEvent(
                    "click", true, false, view, 0, 0, 0, 0, 0
                    , false, false, false, false, 0, null
                );
                node.dispatchEvent(event);
            }
            , webkit_req_fs = view.webkitRequestFileSystem
            , req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem
            , throw_outside = function(ex) {
                (view.setImmediate || view.setTimeout)(function() {
                    throw ex;
                }, 0);
            }
            , force_saveable_type = "application/octet-stream"
            , fs_min_size = 0
        // See https://code.google.com/p/chromium/issues/detail?id=375297#c7 and
        // https://github.com/eligrey/FileSaver.js/commit/485930a#commitcomment-8768047
        // for the reasoning behind the timeout and revocation flow
            , arbitrary_revoke_timeout = 500 // in ms
            , revoke = function(file) {
                var revoker = function() {
                    if (typeof file === "string") { // file is an object URL
                        get_URL().revokeObjectURL(file);
                    } else { // file is a File
                        file.remove();
                    }
                };
                if (view.chrome) {
                    revoker();
                } else {
                    setTimeout(revoker, arbitrary_revoke_timeout);
                }
            }
            , dispatch = function(filesaver, event_types, event) {
                event_types = [].concat(event_types);
                var i = event_types.length;
                while (i--) {
                    var listener = filesaver["on" + event_types[i]];
                    if (typeof listener === "function") {
                        try {
                            listener.call(filesaver, event || filesaver);
                        } catch (ex) {
                            throw_outside(ex);
                        }
                    }
                }
            }
            , auto_bom = function(blob) {
                // prepend BOM for UTF-8 XML and text/* types (including HTML)
                if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
                    return new Blob(["\ufeff", blob], {type: blob.type});
                }
                return blob;
            }
            , FileSaver = function(blob, name) {
                blob = auto_bom(blob);
                // First try a.download, then web filesystem, then object URLs
                var
                    filesaver = this
                    , type = blob.type
                    , blob_changed = false
                    , object_url
                    , target_view
                    , dispatch_all = function() {
                        dispatch(filesaver, "writestart progress write writeend".split(" "));
                    }
                // on any filesys errors revert to saving with object URLs
                    , fs_error = function() {
                        // don't create more object URLs than needed
                        if (blob_changed || !object_url) {
                            object_url = get_URL().createObjectURL(blob);
                        }
                        if (target_view) {
                            target_view.location.href = object_url;
                        } else {
                            var new_tab = view.open(object_url, "_blank");
                            if (new_tab == undefined && typeof safari !== "undefined") {
                                //Apple do not allow window.open, see http://bit.ly/1kZffRI
                                view.location.href = object_url
                            }
                        }
                        filesaver.readyState = filesaver.DONE;
                        dispatch_all();
                        revoke(object_url);
                    }
                    , abortable = function(func) {
                        return function() {
                            if (filesaver.readyState !== filesaver.DONE) {
                                return func.apply(this, arguments);
                            }
                        };
                    }
                    , create_if_not_found = {create: true, exclusive: false}
                    , slice
                    ;
                filesaver.readyState = filesaver.INIT;
                if (!name) {
                    name = "download";
                }
                if (can_use_save_link) {
                    object_url = get_URL().createObjectURL(blob);
                    save_link.href = object_url;
                    save_link.download = name;
                    click(save_link);
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                    revoke(object_url);
                    return;
                }
                // Object and web filesystem URLs have a problem saving in Google Chrome when
                // viewed in a tab, so I force save with application/octet-stream
                // http://code.google.com/p/chromium/issues/detail?id=91158
                // Update: Google errantly closed 91158, I submitted it again:
                // https://code.google.com/p/chromium/issues/detail?id=389642
                if (view.chrome && type && type !== force_saveable_type) {
                    slice = blob.slice || blob.webkitSlice;
                    blob = slice.call(blob, 0, blob.size, force_saveable_type);
                    blob_changed = true;
                }
                // Since I can't be sure that the guessed media type will trigger a download
                // in WebKit, I append .download to the filename.
                // https://bugs.webkit.org/show_bug.cgi?id=65440
                if (webkit_req_fs && name !== "download") {
                    name += ".download";
                }
                if (type === force_saveable_type || webkit_req_fs) {
                    target_view = view;
                }
                if (!req_fs) {
                    fs_error();
                    return;
                }
                fs_min_size += blob.size;
                req_fs(view.TEMPORARY, fs_min_size, abortable(function(fs) {
                    fs.root.getDirectory("saved", create_if_not_found, abortable(function(dir) {
                        var save = function() {
                            dir.getFile(name, create_if_not_found, abortable(function(file) {
                                file.createWriter(abortable(function(writer) {
                                    writer.onwriteend = function(event) {
                                        target_view.location.href = file.toURL();
                                        filesaver.readyState = filesaver.DONE;
                                        dispatch(filesaver, "writeend", event);
                                        revoke(file);
                                    };
                                    writer.onerror = function() {
                                        var error = writer.error;
                                        if (error.code !== error.ABORT_ERR) {
                                            fs_error();
                                        }
                                    };
                                    "writestart progress write abort".split(" ").forEach(function(event) {
                                        writer["on" + event] = filesaver["on" + event];
                                    });
                                    writer.write(blob);
                                    filesaver.abort = function() {
                                        writer.abort();
                                        filesaver.readyState = filesaver.DONE;
                                    };
                                    filesaver.readyState = filesaver.WRITING;
                                }), fs_error);
                            }), fs_error);
                        };
                        dir.getFile(name, {create: false}, abortable(function(file) {
                            // delete file if it already exists
                            file.remove();
                            save();
                        }), abortable(function(ex) {
                            if (ex.code === ex.NOT_FOUND_ERR) {
                                save();
                            } else {
                                fs_error();
                            }
                        }));
                    }), fs_error);
                }), fs_error);
            }
            , FS_proto = FileSaver.prototype
            , saveAs = function(blob, name) {
                return new FileSaver(blob, name);
            }
            ;
        // IE 10+ (native saveAs)
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
            return function(blob, name) {
                return navigator.msSaveOrOpenBlob(auto_bom(blob), name);
            };
        }

        FS_proto.abort = function() {
            var filesaver = this;
            filesaver.readyState = filesaver.DONE;
            dispatch(filesaver, "abort");
        };
        FS_proto.readyState = FS_proto.INIT = 0;
        FS_proto.WRITING = 1;
        FS_proto.DONE = 2;

        FS_proto.error =
            FS_proto.onwritestart =
                FS_proto.onprogress =
                    FS_proto.onwrite =
                        FS_proto.onabort =
                            FS_proto.onerror =
                                FS_proto.onwriteend =
                                    null;

        return saveAs;
    }(
        typeof self !== "undefined" && self
        || typeof window !== "undefined" && window
        || this.content
    ));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
    module.exports.saveAs = saveAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd != null)) {
    define([], function() {
        return saveAs;
    });
}

(function() {
    'use strict';

    angular
        .module('autorenlesungApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.tinymce',
            'angular-google-analytics'
        ])
        .filter('checkmark', function() {
        return function getCheckmark(input) {
            return input ? '\u2713' : '\u2718';
        }})
        .filter('type', function() {
            return function getTypeString(input) {
                return input=='AUTHOR' ? 'Autor' : 'Hit';
            }})
        .filter('gender', function() {
            return function getTypeString(input) {
                return input=='MALE' ? 'Männlich' : 'Weiblich';
            }})
        .filter('unsafe',['$sce',  function($sce) {
            return $sce.trustAsHtml;
        }])
        .config(['AnalyticsProvider', function (AnalyticsProvider) {
            // Add configuration code as desired
            AnalyticsProvider.setAccount('UA-8591059-1');
        }])
        .run(run);

    run.$inject = ['stateHandler', '$rootScope', '$document', 'Analytics'];

    function run(stateHandler, $rootScope, $document, Analytics) {
        stateHandler.initialize();
        $rootScope.$on('$stateChangeSuccess', function() {
            $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('info', {
            parent: 'app',
            url: '/info/{url_id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-static-pages/info.html',
                    controller: 'InfoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'StaticPage', function($stateParams, StaticPage) {
                    return StaticPage.get({id : $stateParams.url_id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'static-page',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('InfoController', InfoController);

    InfoController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'StaticPage', 'entity'];

    function InfoController ($scope, Principal, LoginService, $state, StaticPage, entity) {
        var vm = this;

        vm.staticPage = entity;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-reservation', {
            parent: 'app',
            url: '/event/{id}/reservation',
            data: {
                authorities: [],
                pageTitle: 'Reservierung'
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-reservation/user-reservation.html',
                    controller: 'UserReservationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                event: ['$stateParams', 'Event', function($stateParams, Event) {
                    return Event.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('user-reservation-success', {
            parent: 'app',
            url: '/reservation-success',
            data: {
                authorities: [],
                pageTitle: 'Reservierung erfolgreich'
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-reservation/user-reservation-success.html'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('UserReservationController', UserReservationController);

    UserReservationController.$inject = ['$scope', '$state', 'Reservation', 'ParseLinks', 'AlertService', 'Artist', '$stateParams', 'event', 'AccommodationSuggestion'];

    function UserReservationController ($scope, $state, Reservation, ParseLinks, AlertService, Artist, $stateParams, event, AccommodationSuggestion) {
        var vm = this;

        vm.reservation = {};
        vm.accommodationSuggestion = {};
        vm.reservation.eventId = $stateParams.id;
        vm.event = event;
        vm.artist = Artist.get({id: vm.event.artistId});
        vm.save = save;
        vm.error = null;
        vm.tos = false;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        var lessonStartStartTime = new Date();
        lessonStartStartTime.setHours(7);
        lessonStartStartTime.setMinutes(20);
        lessonStartStartTime.setSeconds(0);
        lessonStartStartTime.setMilliseconds(0);
        var lessonStartEndTime = new Date();
        lessonStartEndTime.setHours(8);
        lessonStartEndTime.setMinutes(30);
        lessonStartEndTime.setSeconds(0);
        lessonStartEndTime.setMilliseconds(0);
        var breakFromStartTime = new Date();
        breakFromStartTime.setHours(9);
        breakFromStartTime.setMinutes(0);
        breakFromStartTime.setSeconds(0);
        breakFromStartTime.setMilliseconds(0);
        var breakFromEndTime = new Date();
        breakFromEndTime.setHours(10);
        breakFromEndTime.setMinutes(50);
        breakFromEndTime.setSeconds(0);
        breakFromEndTime.setMilliseconds(0);
        var breakToStartTime = new Date();
        breakToStartTime.setHours(9);
        breakToStartTime.setMinutes(10);
        breakToStartTime.setSeconds(0);
        breakToStartTime.setMilliseconds(0);
        var breakToEndTime = new Date();
        breakToEndTime.setHours(11);
        breakToEndTime.setMinutes(15);
        breakToEndTime.setSeconds(0);
        breakToEndTime.setMilliseconds(0);

        vm.timesLessonStart = timeRange(lessonStartStartTime, lessonStartEndTime);
        vm.timesBreakFrom = timeRange(breakFromStartTime, breakFromEndTime);
        vm.timesBreakTo =timeRange(breakToStartTime, breakToEndTime);

        function timeRange(from, to) {
            var range = []
            range.push(from)
            var current = from
            while(current.getTime() != to.getTime()) {
                current = incrementedDate(current)
                range.push(current)
            }
            return range
        }

        function incrementedDate(old) {
            var d = new Date(old);
            d.setMinutes(d.getMinutes() + 5);
            return d;
        }

        function save() {
            vm.isSaving = true;

            //save suggestion first if given
            if(acommodationSuggestionExists()) {
                AccommodationSuggestion.save(vm.accommodationSuggestion, onAccSaveSuccess, onAccSaveError)
            }
            else {
                Reservation.save(vm.reservation, onSaveSuccess, onSaveError);
            }
        }

        function acommodationSuggestionExists() {
            return (vm.accommodationSuggestion.name!=null && vm.accommodationSuggestion.name.length>0) ||
                   (vm.accommodationSuggestion.email!=null && vm.accommodationSuggestion.email.length>0) ||
                   (vm.accommodationSuggestion.phone!=null && vm.accommodationSuggestion.phone.length>0) ||
                   (vm.accommodationSuggestion.comment!=null && vm.accommodationSuggestion.comment.length>0)
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:reservationUpdate', result);
            vm.isSaving = false;
            vm.error = null;
            $state.go("user-reservation-success");
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.error = true;
        }

        function onAccSaveSuccess (result) {
            console.log(result);
            vm.reservation.accommodationSuggestionsId = result.id;
            Reservation.save(vm.reservation, onSaveSuccess, onSaveError);
            vm.error = null;
        }

        function onAccSaveError () {
            vm.isSaving = false;
            vm.error = true;
        }

        vm.datePickerOpenStatus.desiredDate = false;
        vm.datePickerOpenStatus.alternateDate = false;
        vm.datePickerOpenStatus.lessonStart = false;
        vm.datePickerOpenStatus.breakFrom = false;
        vm.datePickerOpenStatus.breakTo = false;
        vm.datePickerOpenStatus.submissionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-price-inquiry', {
            parent: 'app',
            url: '/event/{id}/price-inquiry',
            data: {
                authorities: [],
                pageTitle: 'Preisanfrage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-price-inquiry/user-price-inquiry.html',
                    controller: 'UserPriceInquiryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                event: ['$stateParams', 'Event', function($stateParams, Event) {
                    return Event.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('user-price-inquiry-success', {
            parent: 'app',
            url: '/price-inquiry-success',
            data: {
                authorities: [],
                pageTitle: 'Preisanfrage erfolgreich'
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-price-inquiry/user-price-inquiry-success.html'
                }
            }
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('UserPriceInquiryController', UserPriceInquiryController);

    UserPriceInquiryController.$inject = ['$scope', '$state', 'PriceInquiry', 'ParseLinks', 'AlertService', 'Artist', '$stateParams', 'event'];

    function UserPriceInquiryController ($scope, $state, PriceInquiry, ParseLinks, AlertService, Artist, $stateParams, event) {
        var vm = this;

        vm.priceInquiry = {};
        vm.priceInquiry.eventId = $stateParams.id;
        vm.event = event;
        vm.artist = Artist.get({id: vm.event.artistId});
        vm.save = save;
        vm.error = null;
        vm.tos = false;

        function save() {
            vm.isSaving = true;
            PriceInquiry.save(vm.priceInquiry, onSaveSuccess, onSaveError)
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:priceInquiryUpdate', result);
            vm.isSaving = false;
            $state.go("user-price-inquiry-success");
            vm.error = null;
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.error = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('HitDetailController', HitDetailController);

    HitDetailController.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Artist', 'Event', 'Placement', 'EventsPerArtist', 'PlacementsPerArtist'];

    function HitDetailController($scope, $state, $rootScope, $stateParams, previousState, DataUtils, entity, Artist, Event, Placement, EventsPerArtist, PlacementsPerArtist) {
        var vm = this;

        vm.artist = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var actualPageTitle = vm.artist.title.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase();
        if(actualPageTitle !=$stateParams.pageTitle) {
            $state.go("hit-detail", {
                id: vm.artist.id,
                pageTitle: actualPageTitle
            });
        }

        vm.artist.events = EventsPerArtist.get({id : vm.artist.id, active: true});
        vm.artist.placements = PlacementsPerArtist.get({id : vm.artist.id});

        var unsubscribe = $rootScope.$on('autorenlesungApp:artistUpdate', function(event, result) {
            vm.artist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('hits', {
            parent: 'app',
            url: '/hits',
            data: {
                authorities: [],
                pageTitle: "Hits"
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-hit/hits.html',
                    controller: 'HitController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                hits: ['Hit', function(Hit) {
                    return Hit.query();
                }]
            }
        })
        .state('hit-detail-id-only', {
            parent: 'hits',
            url: '/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-hit/hit-detail.html',
                    controller: 'HitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Artist', function($stateParams, Artist) {
                    return Artist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'artist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hit-detail', {
            parent: 'hits',
            url: '/{id}/{pageTitle}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-hit/hit-detail.html',
                    controller: 'HitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Artist', function($stateParams, Artist) {
                    return Artist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'artist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('Hit', Hit);

    Hit.$inject = ['$resource'];

    function Hit ($resource) {
        var resourceUrl =  'api/hits';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('HitController', HitController);

    HitController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'Hit', 'hits'];

    function HitController ($scope, Principal, LoginService, $state, Hit, hits) {
        var vm = this;
        vm.hits = hits;

        vm.urlify = urlify;

        function urlify (name) {
            return name.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase();
        }


        $scope.$watch('vm.age', function (nVal, oVal)
        {
            // if searchStr is still the same..
            // go ahead and retrieve the data
            if (nVal != oVal)
            {
                if(nVal==null) {
                    vm.authors = Author.query();
                } else {
                    vm.authors = Author.query({age: nVal});
                }
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('AuthorDetailController', AuthorDetailController);

    AuthorDetailController.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Artist', 'Event', 'Placement', 'EventsPerArtist', 'PlacementsPerArtist'];

    function AuthorDetailController($scope, $state, $rootScope, $stateParams, previousState, DataUtils, entity, Artist, Event, Placement, EventsPerArtist, PlacementsPerArtist) {
        var vm = this;

        vm.artist = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var actualPageTitle = vm.artist.title.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase();
        if(actualPageTitle !=$stateParams.pageTitle) {
            $state.go("author-detail", {
                id: vm.artist.id,
                pageTitle: actualPageTitle
            });
        }

        vm.artist.events = EventsPerArtist.get({id : vm.artist.id, active: true});
        vm.artist.placements = PlacementsPerArtist.get({id : vm.artist.id});

        var unsubscribe = $rootScope.$on('autorenlesungApp:artistUpdate', function(event, result) {
            vm.artist = result;
        });


        $scope.$on('$destroy', unsubscribe);
    }
})();


(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('authors', {
            parent: 'app',
            url: '/authors',
            data: {
                authorities: [],
                pageTitle: 'Autoren'
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-author/authors.html',
                    controller: 'AuthorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authors: ['Author', function(Author) {
                    return Author.query();
                }],
                hits: ['Hit', function(Hit) {
                    return Hit.query();
                }]
            }
        })
        .state('author-detail-id-only', {
            parent: 'authors',
            url: '/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-author/author-detail.html',
                    controller: 'AuthorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Artist', function($stateParams, Artist) {
                    return Artist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'artist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('author-detail', {
            parent: 'authors',
            url: '/{id}/{pageTitle}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-author/author-detail.html',
                    controller: 'AuthorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Artist', function($stateParams, Artist) {
                    return Artist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'artist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('Author', Author);

    Author.$inject = ['$resource'];

    function Author ($resource) {
        var resourceUrl =  'api/authors';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('AuthorController', AuthorController);

    AuthorController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'Author', 'authors', 'Hit', 'hits'];

    function AuthorController ($scope, Principal, LoginService, $state, Author, authors, Hits, hits) {
        var vm = this;
        vm.authors = authors;
        vm.hits = hits;

        vm.urlify = urlify;

        function urlify (name) {
            return name.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase();
        }

        $scope.$watch('vm.age', function (nVal, oVal)
        {
            // if searchStr is still the same..
            // go ahead and retrieve the data
            if (nVal != oVal)
            {
                if(nVal==null) {
                    vm.authors = Author.query();
                } else {
                    vm.authors = Author.query({age: nVal});
                }
            }

        });

    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tos', {
            parent: 'app',
            url: '/tos',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/tos/tos.html'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" >{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'StaticPage'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, StaticPage) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.staticPages = [];

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        loadAllPages();

        function loadAllPages() {
            StaticPage.query(function(result) {
                vm.staticPages = result;
            });
        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('NewsletterDialogController', NewsletterDialogController);

    NewsletterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'Newsletter'];

    function NewsletterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, Newsletter) {
        var vm = this;

        vm.newsletter = {};
        vm.clear = clear;
        vm.save = save;
        vm.error = null;
        vm.tos = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            vm.error = null;
        }

        function save () {
            vm.isSaving = true;
            Newsletter.save(vm.newsletter, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.error = null;
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.error = true;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('Newsletter', Newsletter);

    Newsletter.$inject = ['$resource'];

    function Newsletter ($resource) {
        var resourceUrl =  'api/newsletter';

        return $resource(resourceUrl, {}, {
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('home.newsletter', {
            parent: 'home',
            url: 'newsletter',
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/home/newsletter-dialog.html',
                    controller: 'NewsletterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                }).result.then(function() {
                    $state.go('home', null, { reload: 'home' });
                }, function() {
                    $state.go('home');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'FilteredCurrentIssue'];

    function HomeController ($scope, Principal, LoginService, $state, FilteredCurrentIssue) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.currentIssues = FilteredCurrentIssue.query();

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('StaticPageDialogController', StaticPageDialogController);

    StaticPageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'StaticPage'];

    function StaticPageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, StaticPage) {
        var vm = this;

        vm.staticPage = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.staticPage.id !== null) {
                StaticPage.update(vm.staticPage, onSaveSuccess, onSaveError);
            } else {
                StaticPage.save(vm.staticPage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:staticPageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        $scope.tinymceOptions = {
            onChange: function(e) {
                // put logic here for keypress and cut/paste changes
            },
            inline: false,
            plugins : 'advlist autolink link image lists charmap print preview table contextmenu',
            skin: 'lightgray',
            theme : 'modern',
            height: 150,
            image_advtab: true,
            language : 'de'
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('StaticPageDetailController', StaticPageDetailController);

    StaticPageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'StaticPage'];

    function StaticPageDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, StaticPage) {
        var vm = this;

        vm.staticPage = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('autorenlesungApp:staticPageUpdate', function(event, result) {
            vm.staticPage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('StaticPageDeleteController',StaticPageDeleteController);

    StaticPageDeleteController.$inject = ['$uibModalInstance', 'entity', 'StaticPage'];

    function StaticPageDeleteController($uibModalInstance, entity, StaticPage) {
        var vm = this;

        vm.staticPage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            StaticPage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('static-page', {
            parent: 'entity',
            url: '/admin/static-page',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Seiten'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/static-page/static-pages.html',
                    controller: 'StaticPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('static-page-detail', {
            parent: 'entity',
            url: '/admin/static-page/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Seiten'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/static-page/static-page-detail.html',
                    controller: 'StaticPageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'StaticPage', function($stateParams, StaticPage) {
                    return StaticPage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'static-page',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('static-page-detail.edit', {
            parent: 'static-page-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/static-page/static-page-dialog.html',
                    controller: 'StaticPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StaticPage', function(StaticPage) {
                            return StaticPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('static-page.new', {
            parent: 'static-page',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/static-page/static-page-dialog.html',
                    controller: 'StaticPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                content: null,
                                position: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('static-page', null, { reload: 'static-page' });
                }, function() {
                    $state.go('static-page');
                });
            }]
        })
        .state('static-page.edit', {
            parent: 'static-page',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/static-page/static-page-dialog.html',
                    controller: 'StaticPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StaticPage', function(StaticPage) {
                            return StaticPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('static-page', null, { reload: 'static-page' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('static-page.delete', {
            parent: 'static-page',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/static-page/static-page-delete-dialog.html',
                    controller: 'StaticPageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StaticPage', function(StaticPage) {
                            return StaticPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('static-page', null, { reload: 'static-page' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('StaticPage', StaticPage);

    StaticPage.$inject = ['$resource'];

    function StaticPage ($resource) {
        var resourceUrl =  'api/static-pages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('StaticPageController', StaticPageController);

    StaticPageController.$inject = ['$scope', '$state', 'DataUtils', 'StaticPage'];

    function StaticPageController ($scope, $state, DataUtils, StaticPage) {
        var vm = this;

        vm.staticPages = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            StaticPage.query(function(result) {
                vm.staticPages = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ReservationDialogController', ReservationDialogController);

    ReservationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Reservation', 'AccommodationSuggestion', 'Event'];

    function ReservationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Reservation, AccommodationSuggestion, Event) {
        var vm = this;

        vm.reservation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.accommodationsuggestions = AccommodationSuggestion.query({filter: 'reservation-is-null'});
        $q.all([vm.reservation.$promise, vm.accommodationsuggestions.$promise]).then(function() {
            if (!vm.reservation.accommodationSuggestionsId) {
                return $q.reject();
            }
            return AccommodationSuggestion.get({id : vm.reservation.accommodationSuggestionsId}).$promise;
        }).then(function(accommodationSuggestions) {
            vm.accommodationsuggestions.push(accommodationSuggestions);
        });
        vm.events = Event.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reservation.id !== null) {
                Reservation.update(vm.reservation, onSaveSuccess, onSaveError);
            } else {
                Reservation.save(vm.reservation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:reservationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.desiredDate = false;
        vm.datePickerOpenStatus.alternateDate = false;
        vm.datePickerOpenStatus.lessonStart = false;
        vm.datePickerOpenStatus.breakFrom = false;
        vm.datePickerOpenStatus.breakTo = false;
        vm.datePickerOpenStatus.submissionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ReservationDetailController', ReservationDetailController);

    ReservationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Reservation', 'AccommodationSuggestion', 'Event'];

    function ReservationDetailController($scope, $rootScope, $stateParams, previousState, entity, Reservation, AccommodationSuggestion, Event) {
        var vm = this;

        vm.reservation = entity;
        vm.accommodationSuggestion = null;
        vm.previousState = previousState.name;

        if(vm.reservation.accommodationSuggestionsId!=null) {
            vm.accommodationSuggestion = AccommodationSuggestion.get({id: vm.reservation.accommodationSuggestionsId});

        }

        var unsubscribe = $rootScope.$on('autorenlesungApp:reservationUpdate', function(event, result) {
            vm.reservation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ReservationDeleteController',ReservationDeleteController);

    ReservationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Reservation', '$log'];

    function ReservationDeleteController($uibModalInstance, entity, Reservation, $log) {
        var vm = this;

        vm.reservation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            $log.debug("what the hell "+id)
            Reservation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reservation', {
            parent: 'entity',
            url: '/reservation',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Reservierungen'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reservation/reservations.html',
                    controller: 'ReservationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                sort: {
                    value: 'submissionDate,desc',
                    squash: true
                }
            },
            resolve: {
            }
        })
        .state('reservation-detail', {
            parent: 'entity',
            url: '/reservation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Reservation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reservation/reservation-detail.html',
                    controller: 'ReservationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Reservation', function($stateParams, Reservation) {
                    return Reservation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'reservation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('reservation-detail.edit', {
            parent: 'reservation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reservation/reservation-dialog.html',
                    controller: 'ReservationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Reservation', function(Reservation) {
                            return Reservation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reservation.new', {
            parent: 'reservation',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reservation/reservation-dialog.html',
                    controller: 'ReservationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                organizationName: null,
                                organizationAddress: null,
                                organizationPhone: null,
                                organizerName: null,
                                organizerPhone: null,
                                organizerEmail: null,
                                desiredDate: null,
                                alternateDate: null,
                                lessonStart: null,
                                breakFrom: null,
                                breakTo: null,
                                numberOfAttendees: null,
                                attendeeDescription: null,
                                numberOfEvents: null,
                                comment: null,
                                submissionDate: null,
                                confirmationMailed: null,
                                confirmationReceived: null,
                                confirmationMailedToAuthor: null,
                                note: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('reservation', null, { reload: 'reservation' });
                }, function() {
                    $state.go('reservation');
                });
            }]
        })
        .state('reservation.edit', {
            parent: 'reservation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reservation/reservation-dialog.html',
                    controller: 'ReservationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Reservation', function(Reservation) {
                            return Reservation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reservation', null, { reload: 'reservation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reservation.delete', {
            parent: 'reservation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reservation/reservation-delete-dialog.html',
                    controller: 'ReservationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Reservation', function(Reservation) {
                            return Reservation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reservation', null, { reload: 'reservation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('Reservation', Reservation);

    Reservation.$inject = ['$resource', 'DateUtils'];

    function Reservation ($resource, DateUtils) {
        var resourceUrl =  'api/reservations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.desiredDate = DateUtils.convertDateTimeFromServer(data.desiredDate);
                        data.alternateDate = DateUtils.convertDateTimeFromServer(data.alternateDate);
                        data.lessonStart = DateUtils.convertDateTimeFromServer(data.lessonStart);
                        data.breakFrom = DateUtils.convertDateTimeFromServer(data.breakFrom);
                        data.breakTo = DateUtils.convertDateTimeFromServer(data.breakTo);
                        data.submissionDate = DateUtils.convertDateTimeFromServer(data.submissionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ReservationController', ReservationController);

    ReservationController.$inject = ['$http','$scope', '$state', 'Reservation', 'ParseLinks', 'AlertService'];

    function ReservationController ($http, $scope, $state, Reservation, ParseLinks, AlertService) {
        var vm = this;

        vm.reservations = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;

        vm.exportReservations = exportReservations;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        loadAll();

        function loadAll () {
            Reservation.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.reservations.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.reservations = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function exportReservations () {
            vm.isExporting = true;
            $http.post('api/reservationExport', {from: vm.from, to: vm.to}).then(function (response) {
                var blob = new Blob([response.data], {
                    type: "text/csv;charset=UTF-8"
                });

                var filename = "reservierungen.csv";
                saveAs(blob, filename);
                vm.isExporting = false;
            }, function (error) {
                vm.isExporting = false;
                AlertService.error(error);
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PriceInquiryDialogController', PriceInquiryDialogController);

    PriceInquiryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PriceInquiry', 'Event'];

    function PriceInquiryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PriceInquiry, Event) {
        var vm = this;

        vm.priceInquiry = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.events = Event.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.priceInquiry.id !== null) {
                PriceInquiry.update(vm.priceInquiry, onSaveSuccess, onSaveError);
            } else {
                PriceInquiry.save(vm.priceInquiry, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:priceInquiryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.submissionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PriceInquiryDetailController', PriceInquiryDetailController);

    PriceInquiryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PriceInquiry', 'Event'];

    function PriceInquiryDetailController($scope, $rootScope, $stateParams, previousState, entity, PriceInquiry, Event) {
        var vm = this;

        vm.priceInquiry = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('autorenlesungApp:priceInquiryUpdate', function(event, result) {
            vm.priceInquiry = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PriceInquiryDeleteController',PriceInquiryDeleteController);

    PriceInquiryDeleteController.$inject = ['$uibModalInstance', 'entity', 'PriceInquiry'];

    function PriceInquiryDeleteController($uibModalInstance, entity, PriceInquiry) {
        var vm = this;

        vm.priceInquiry = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PriceInquiry.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('price-inquiry', {
            parent: 'entity',
            url: '/price-inquiry',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Preisanfragen'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/price-inquiry/price-inquiries.html',
                    controller: 'PriceInquiryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                sort: {
                    value: 'submissionDate,desc',
                    squash: true
                }
            },
            resolve: {
            }
        })
        .state('price-inquiry-detail', {
            parent: 'entity',
            url: '/price-inquiry/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PriceInquiry'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/price-inquiry/price-inquiry-detail.html',
                    controller: 'PriceInquiryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PriceInquiry', function($stateParams, PriceInquiry) {
                    return PriceInquiry.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'price-inquiry',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('price-inquiry-detail.edit', {
            parent: 'price-inquiry-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/price-inquiry/price-inquiry-dialog.html',
                    controller: 'PriceInquiryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PriceInquiry', function(PriceInquiry) {
                            return PriceInquiry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('price-inquiry.new', {
            parent: 'price-inquiry',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/price-inquiry/price-inquiry-dialog.html',
                    controller: 'PriceInquiryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                organizationName: null,
                                organizerName: null,
                                organizerEmail: null,
                                comment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('price-inquiry', null, { reload: 'price-inquiry' });
                }, function() {
                    $state.go('price-inquiry');
                });
            }]
        })
        .state('price-inquiry.edit', {
            parent: 'price-inquiry',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/price-inquiry/price-inquiry-dialog.html',
                    controller: 'PriceInquiryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PriceInquiry', function(PriceInquiry) {
                            return PriceInquiry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('price-inquiry', null, { reload: 'price-inquiry' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('price-inquiry.delete', {
            parent: 'price-inquiry',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/price-inquiry/price-inquiry-delete-dialog.html',
                    controller: 'PriceInquiryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PriceInquiry', function(PriceInquiry) {
                            return PriceInquiry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('price-inquiry', null, { reload: 'price-inquiry' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('PriceInquiry', PriceInquiry);

    PriceInquiry.$inject = ['$resource', 'DateUtils'];

    function PriceInquiry ($resource, DateUtils) {
        var resourceUrl =  'api/price-inquiries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.submissionDate = DateUtils.convertDateTimeFromServer(data.submissionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PriceInquiryController', PriceInquiryController);

    PriceInquiryController.$inject = ['$http', '$scope', '$state', 'PriceInquiry', 'ParseLinks', 'AlertService'];

    function PriceInquiryController ($http, $scope, $state, PriceInquiry, ParseLinks, AlertService) {
        var vm = this;

        vm.priceInquiries = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse =false;
        vm.exportPriceInquiries = exportPriceInquiries;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        loadAll();

        function loadAll () {
            PriceInquiry.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.priceInquiries.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.priceInquiries = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function exportPriceInquiries () {
            vm.isExporting = true;
            $http.post('api/priceInquiryExport', {from: vm.from, to: vm.to}).then(function (response) {
                var blob = new Blob([response.data], {
                    type: "text/csv;charset=UTF-8"
                });

                var filename = "preisanfragen.csv";
                saveAs(blob, filename);
                vm.isExporting = false;
            }, function (error) {
                vm.isExporting = false;
                AlertService.error(error);
            })
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('PlacementsPerArtist', PlacementsPerArtist);

    PlacementsPerArtist.$inject = ['$resource'];

    function PlacementsPerArtist ($resource) {
        var resourceUrl =  'api/artists/:id/placements';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PlacementDialogController', PlacementDialogController);

    PlacementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Placement', 'Artist'];

    function PlacementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Placement, Artist) {
        var vm = this;

        vm.placement = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.placement.artistId = $stateParams.id;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.placement.id !== null) {
                Placement.update(vm.placement, onSaveSuccess, onSaveError);
            } else {
                Placement.save(vm.placement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:placementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImage = function ($file, placement) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        placement.image = base64Data;
                        placement.imageContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PlacementDetailController', PlacementDetailController);

    PlacementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Placement', 'Artist'];

    function PlacementDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Placement, Artist) {
        var vm = this;

        vm.placement = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.artist = Artist.get({id : $stateParams.id});

        var unsubscribe = $rootScope.$on('autorenlesungApp:placementUpdate', function(event, result) {
            vm.placement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PlacementDeleteController',PlacementDeleteController);

    PlacementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Placement'];

    function PlacementDeleteController($uibModalInstance, entity, Placement) {
        var vm = this;

        vm.placement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Placement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('placement-detail', {
                parent: 'artist-detail',
                url: '/placement/{placement_id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Werbung'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/placement/placement-detail.html',
                        controller: 'PlacementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Placement', function ($stateParams, Placement) {
                        return Placement.get({id: $stateParams.placement_id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'placement',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('placement-detail.edit', {
                parent: 'placement-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/placement/placement-dialog.html',
                        controller: 'PlacementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Placement', function (Placement) {
                                return Placement.get({id: $stateParams.placement_id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('placement-detail', { id: $stateParams.id, placement_id: $stateParams.placement_id}, { reload: 'placement-detail' });
                    }, function() {
                        $state.go('placement-detail',  { id: $stateParams.id, placement_id: $stateParams.placement_id});
                    });
                }]
            })
            .state('artist-detail.new-placement', {
                parent: 'artist-detail',
                url: '/new-placement',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/placement/placement-dialog.html',
                        controller: 'PlacementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    description: null,
                                    url: null,
                                    image: null,
                                    imageContentType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('artist-detail', null, {reload: 'artist-detail'});
                    }, function () {
                        $state.go('artist-detail');
                    });
                }]
            })
            .state('artist-detail.edit-placement', {
                parent: 'artist-detail',
                url: '/placement/{placement_id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/placement/placement-dialog.html',
                        controller: 'PlacementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Placement', function (Placement) {
                                return Placement.get({id: $stateParams.placement_id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('artist-detail', null, {reload: 'artist-detail'});
                    }, function () {
                        $state.go('artist-detail');
                    });
                }]
            })
            .state('artist-detail.delete-placement', {
                parent: 'artist-detail',
                url: '/placement/{placement_id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/placement/placement-delete-dialog.html',
                        controller: 'PlacementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Placement', function (Placement) {
                                return Placement.get({id: $stateParams.placement_id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('artist-detail', null, {reload: 'artist-detail'});
                    }, function () {
                        $state.go('artist-detail');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('Placement', Placement);

    Placement.$inject = ['$resource'];

    function Placement ($resource) {
        var resourceUrl =  'api/placements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PlacementController', PlacementController);

    PlacementController.$inject = ['$scope', '$state', 'DataUtils', 'Placement'];

    function PlacementController ($scope, $state, DataUtils, Placement) {
        var vm = this;

        vm.placements = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            Placement.query(function(result) {
                vm.placements = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('NewsDialogController', NewsDialogController);

    NewsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'News'];

    function NewsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.news.id !== null) {
                News.update(vm.news, onSaveSuccess, onSaveError);
            } else {
                News.save(vm.news, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:newsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('NewsDetailController', NewsDetailController);

    NewsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'News'];

    function NewsDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('autorenlesungApp:newsUpdate', function(event, result) {
            vm.news = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('NewsDeleteController',NewsDeleteController);

    NewsDeleteController.$inject = ['$uibModalInstance', 'entity', 'News'];

    function NewsDeleteController($uibModalInstance, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            News.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('news', {
            parent: 'entity',
            url: '/admin/news',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'News'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/news/news.html',
                    controller: 'NewsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('news-detail', {
            parent: 'entity',
            url: '/admin/news/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'News'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/news/news-detail.html',
                    controller: 'NewsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'News', function($stateParams, News) {
                    return News.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'news',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('news-detail.edit', {
            parent: 'news-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('news.new', {
            parent: 'news',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                content: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('news');
                });
            }]
        })
        .state('news.edit', {
            parent: 'news',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('news.delete', {
            parent: 'news',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-delete-dialog.html',
                    controller: 'NewsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('News', News);

    News.$inject = ['$resource'];

    function News ($resource) {
        var resourceUrl =  'api/news/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('NewsController', NewsController);

    NewsController.$inject = ['$scope', '$state', 'DataUtils', 'News', 'ParseLinks', 'AlertService'];

    function NewsController ($scope, $state, DataUtils, News, ParseLinks, AlertService) {
        var vm = this;

        vm.news = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            News.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.news.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.news = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('EventsPerArtist', EventsPerArtist);

    EventsPerArtist.$inject = ['$resource'];

    function EventsPerArtist ($resource) {
        var resourceUrl =  'api/artists/:id/events';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('EventDialogController', EventDialogController);

    EventDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Event', 'Reservation', 'PriceInquiry', 'CurrentIssue', 'Artist'];

    function EventDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Event, Reservation, PriceInquiry, CurrentIssue, Artist) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.event.artistId = $stateParams.id;

        if(vm.event.artistContact == null) vm.event.artistContact = false;
        if(vm.event.accommodationRequest == null) vm.event.accommodationRequest = false;
        if(vm.event.active == null) vm.event.active = true;
        if(vm.event.priceInformationText == null) vm.event.priceInformationText = ' ';


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.event.id !== null) {
                Event.update(vm.event, onSaveSuccess, onSaveError);
            } else {
                Event.save(vm.event, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:eventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        $scope.tinymceOptions = {
            onChange: function(e) {
                // put logic here for keypress and cut/paste changes
            },
            inline: false,
            plugins : 'advlist autolink link image lists charmap print preview table contextmenu',
            skin: 'lightgray',
            theme : 'modern',
            height: 150,
            image_advtab: true,
            language : 'de'
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('EventDetailController', EventDetailController);

    EventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Event', 'Reservation', 'PriceInquiry', 'CurrentIssue', 'Artist'];

    function EventDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Event, Reservation, PriceInquiry, CurrentIssue, Artist) {
        var vm = this;

        vm.event = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.artist = Artist.get({id : $stateParams.id});

        var unsubscribe = $rootScope.$on('autorenlesungApp:eventUpdate', function(event, result) {
            vm.event = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('EventDeleteController',EventDeleteController);

    EventDeleteController.$inject = ['$uibModalInstance', 'entity', 'Event'];

    function EventDeleteController($uibModalInstance, entity, Event) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Event.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('EventContentController', EventContentController);

    EventContentController.$inject = ['$scope', '$rootScope', '$state',  '$stateParams', 'previousState', 'DataUtils', 'entity', 'Artist', 'Event', 'Placement'];

    function EventContentController($scope, $rootScope, $state, $stateParams, previousState, DataUtils, entity, Artist, Event, Placement) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.event.artistId = $stateParams.id;
        vm.artist = Artist.get({id : $stateParams.id});

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.event.id !== null) {
                Event.update(vm.event, onSaveSuccess, onSaveError);
            } else {
                Event.save(vm.event, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:eventUpdate', result);
            vm.isSaving = false;
            $state.go("event-detail", { "id": vm.event.artistId, "event_id": vm.event.id});
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        //var unsubscribe = $rootScope.$on('autorenlesungApp:artistUpdate', function(event, result) {
        //    vm.artist = result;
        //});
        //$scope.$on('$destroy', unsubscribe);

        $scope.tinymceOptions = {
            onChange: function(e) {
                // put logic here for keypress and cut/paste changes
            },
            inline: false,
            plugins : 'advlist autolink link image lists charmap print preview table contextmenu',
            skin: 'lightgray',
            theme : 'modern',
            height: 500,
            image_advtab: true,
            language : 'de'
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-detail', {
            parent: 'artist-detail',
            url: '/event/{event_id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Veranstaltung'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event/event-detail.html',
                    controller: 'EventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Event', function($stateParams, Event) {
                    return Event.get({id : $stateParams.event_id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('event-content', {
            parent: 'event-detail',
            url: '/content',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Veranstaltung'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event/event-content.html',
                    controller: 'EventContentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Event', function($stateParams, Event) {
                    return Event.get({id : $stateParams.event_id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('event-detail.edit', {
            parent: 'artist-detail',
            url: '/event/{event_id}/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-dialog.html',
                    controller: 'EventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.event_id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-detail', { id: $stateParams.id, event_id: $stateParams.event_id}, { reload: 'event-detail' });
                }, function() {
                    $state.go('event-detail',  { id: $stateParams.id, event_id: $stateParams.event_id});
                });
            }]
        })
        .state('artist-detail.new-event', {
            parent: 'artist-detail',
            url: '/new-event',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-dialog.html',
                    controller: 'EventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                content: null,
                                artistContact: null,
                                accommodationRequest: null,
                                position: null,
                                active: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('artist-detail', null, { reload: 'artist-detail' });
                }, function() {
                    $state.go('artist-detail');
                });
            }]
        })
        .state('artist-detail.edit-event', {
            parent: 'artist-detail',
            url: '/event/{event_id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-dialog.html',
                    controller: 'EventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.event_id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('artist-detail', null, { reload: 'artist-detail' });
                }, function() {
                    $state.go('artist-detail');
                });
            }]
        })
        .state('artist-detail.delete-event', {
            parent: 'artist-detail',
            url: '/event/{event_id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-delete-dialog.html',
                    controller: 'EventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.event_id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('artist-detail', null, { reload: 'artist-detail' });
                }, function() {
                    $state.go('artist-detail');
                });
            }]
        })
        ;
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('Event', Event);

    Event.$inject = ['$resource'];

    function Event ($resource) {
        var resourceUrl =  'api/events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('EventController', EventController);

    EventController.$inject = ['$scope', '$state', 'DataUtils', 'Event', 'ParseLinks', 'AlertService'];

    function EventController ($scope, $state, DataUtils, Event, ParseLinks, AlertService) {
        var vm = this;

        vm.events = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            Event.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.events.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.events = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('FilteredCurrentIssue', FilteredCurrentIssue);

    FilteredCurrentIssue.$inject = ['$resource', 'DateUtils'];

    function FilteredCurrentIssue ($resource, DateUtils) {
        var resourceUrl =  'api/filtered-current-issues';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('CurrentIssueDialogController', CurrentIssueDialogController);

    CurrentIssueDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CurrentIssue', 'Event'];

    function CurrentIssueDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CurrentIssue, Event) {
        var vm = this;

        vm.currentIssue = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.events = Event.query();

        if(vm.currentIssue.active == null) vm.currentIssue.active = true;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.currentIssue.id !== null) {
                CurrentIssue.update(vm.currentIssue, onSaveSuccess, onSaveError);
            } else {
                CurrentIssue.save(vm.currentIssue, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:currentIssueUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $scope.tinymceOptions = {
            onChange: function(e) {
                // put logic here for keypress and cut/paste changes
            },
            inline: false,
            plugins : 'advlist autolink link image lists charmap print preview table contextmenu',
            skin: 'lightgray',
            theme : 'modern',
            height: 150,
            image_advtab: true,
            language : 'de'
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('CurrentIssueDetailController', CurrentIssueDetailController);

    CurrentIssueDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CurrentIssue', 'Event'];

    function CurrentIssueDetailController($scope, $rootScope, $stateParams, previousState, entity, CurrentIssue, Event) {
        var vm = this;

        vm.currentIssue = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('autorenlesungApp:currentIssueUpdate', function(event, result) {
            vm.currentIssue = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('CurrentIssueDeleteController',CurrentIssueDeleteController);

    CurrentIssueDeleteController.$inject = ['$uibModalInstance', 'entity', 'CurrentIssue'];

    function CurrentIssueDeleteController($uibModalInstance, entity, CurrentIssue) {
        var vm = this;

        vm.currentIssue = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CurrentIssue.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('current-issue', {
            parent: 'entity',
            url: '/admin/current-issue',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Aktuelles'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/current-issue/current-issues.html',
                    controller: 'CurrentIssueController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('current-issue-detail', {
            parent: 'entity',
            url: '/admin/current-issue/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Aktuelles'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/current-issue/current-issue-detail.html',
                    controller: 'CurrentIssueDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CurrentIssue', function($stateParams, CurrentIssue) {
                    return CurrentIssue.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'current-issue',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('current-issue-detail.edit', {
            parent: 'current-issue-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/current-issue/current-issue-dialog.html',
                    controller: 'CurrentIssueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CurrentIssue', function(CurrentIssue) {
                            return CurrentIssue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('current-issue.new', {
            parent: 'current-issue',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/current-issue/current-issue-dialog.html',
                    controller: 'CurrentIssueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                description: null,
                                startDate: null,
                                endDate: null,
                                active: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('current-issue', null, { reload: 'current-issue' });
                }, function() {
                    $state.go('current-issue');
                });
            }]
        })
        .state('current-issue.edit', {
            parent: 'current-issue',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/current-issue/current-issue-dialog.html',
                    controller: 'CurrentIssueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CurrentIssue', function(CurrentIssue) {
                            return CurrentIssue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('current-issue', null, { reload: 'current-issue' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('current-issue.delete', {
            parent: 'current-issue',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/current-issue/current-issue-delete-dialog.html',
                    controller: 'CurrentIssueDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CurrentIssue', function(CurrentIssue) {
                            return CurrentIssue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('current-issue', null, { reload: 'current-issue' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('CurrentIssue', CurrentIssue);

    CurrentIssue.$inject = ['$resource', 'DateUtils'];

    function CurrentIssue ($resource, DateUtils) {
        var resourceUrl =  'api/current-issues/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('CurrentIssueController', CurrentIssueController);

    CurrentIssueController.$inject = ['$scope', '$state', 'CurrentIssue', 'ParseLinks', 'AlertService'];

    function CurrentIssueController ($scope, $state, CurrentIssue, ParseLinks, AlertService) {
        var vm = this;

        vm.currentIssues = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            CurrentIssue.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.currentIssues.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.currentIssues = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ArtistDialogController', ArtistDialogController);

    ArtistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Artist', 'Event', 'Placement'];

    function ArtistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Artist, Event, Placement) {
        var vm = this;

        vm.artist = entity;
        if(vm.artist.active == null) vm.artist.active = true;
        if(vm.artist.type == null) vm.artist.type = 'AUTHOR';

        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.events = Event.query();
        vm.placements = Placement.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.artist.id !== null) {
                Artist.update(vm.artist, onSaveSuccess, onSaveError);
            } else {
                Artist.save(vm.artist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:artistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImage = function ($file, artist) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        artist.image = base64Data;
                        artist.imageContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ArtistDetailController', ArtistDetailController);

    ArtistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'EventsPerArtist', 'PlacementsPerArtist'];

    function ArtistDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, EventsPerArtist, PlacementsPerArtist) {
        var vm = this;

        vm.artist = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        vm.artist.events = EventsPerArtist.get({id : vm.artist.id});
        vm.artist.placements = PlacementsPerArtist.get({id : vm.artist.id});

        var unsubscribe = $rootScope.$on('autorenlesungApp:artistUpdate', function(event, result) {
            vm.artist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ArtistDeleteController',ArtistDeleteController);

    ArtistDeleteController.$inject = ['$uibModalInstance', 'entity', 'Artist'];

    function ArtistDeleteController($uibModalInstance, entity, Artist) {
        var vm = this;

        vm.artist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Artist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ArtistContentController', ArtistContentController);

    ArtistContentController.$inject = ['$scope', '$rootScope', '$state',  '$stateParams', 'previousState', 'DataUtils', 'entity', 'Artist', 'Event', 'Placement', 'EventsPerArtist'];

    function ArtistContentController($scope, $rootScope, $state, $stateParams, previousState, DataUtils, entity, Artist, Event, Placement, EventsPerArtist) {
        var vm = this;

        vm.save = save;
        vm.artist = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.artist.id !== null) {
                Artist.update(vm.artist, onSaveSuccess, onSaveError);
            } else {
                Artist.save(vm.artist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:artistUpdate', result);
            vm.isSaving = false;
            $state.go("artist-detail", { "id": vm.artist.id});
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        $scope.tinymceOptions = {
            onChange: function(e) {
                // put logic here for keypress and cut/paste changes
            },
            inline: false,
            plugins : 'advlist autolink link image lists charmap print preview table contextmenu',
            skin: 'lightgray',
            theme : 'modern',
            height: 500,
            image_advtab: true,
            language : 'de'
        };

        //var unsubscribe = $rootScope.$on('autorenlesungApp:artistUpdate', function(event, result) {
        //    vm.artist = result;
        //});
        //$scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('artist', {
            parent: 'entity',
            url: '/admin/artist',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Künstler'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/artist/artists.html',
                    controller: 'ArtistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('artist-detail', {
            parent: 'entity',
            url: '/admin/artist/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Künstler'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/artist/artist-detail.html',
                    controller: 'ArtistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Artist', function($stateParams, Artist) {
                    return Artist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'artist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('artist-content', {
            parent: 'artist-detail',
            url: '/content',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Künstler'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/artist/artist-content.html',
                    controller: 'ArtistContentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Artist', function($stateParams, Artist) {
                    return Artist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'artist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('artist-detail.edit', {
            parent: 'artist-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/artist/artist-dialog.html',
                    controller: 'ArtistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Artist', function(Artist) {
                            return Artist.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('artist-detail', {}, { reload: 'artist-detail' });
                }, function() {
                    $state.go('artist-detail');
                });
            }]
        })
        .state('artist.new', {
            parent: 'artist',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/artist/artist-dialog.html',
                    controller: 'ArtistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                type: null,
                                title: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                phoneNumber: null,
                                address: null,
                                content: null,
                                image: null,
                                imageContentType: null,
                                position: null,
                                active: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('artist', null, { reload: 'artist' });
                }, function() {
                    $state.go('artist');
                });
            }]
        })
        .state('artist.edit', {
            parent: 'artist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/artist/artist-dialog.html',
                    controller: 'ArtistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Artist', function(Artist) {
                            return Artist.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('artist', null, { reload: 'artist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('artist.delete', {
            parent: 'artist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/artist/artist-delete-dialog.html',
                    controller: 'ArtistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Artist', function(Artist) {
                            return Artist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('artist', null, { reload: 'artist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('Artist', Artist);

    Artist.$inject = ['$resource'];

    function Artist ($resource) {
        var resourceUrl =  'api/artists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ArtistController', ArtistController);

    ArtistController.$inject = ['$scope', '$state', 'DataUtils', 'Artist', 'ParseLinks', 'AlertService'];

    function ArtistController ($scope, $state, DataUtils, Artist, ParseLinks, AlertService) {
        var vm = this;

        vm.artists = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            Artist.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.artists.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.artists = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('AccommodationSuggestionDialogController', AccommodationSuggestionDialogController);

    AccommodationSuggestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AccommodationSuggestion'];

    function AccommodationSuggestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AccommodationSuggestion) {
        var vm = this;

        vm.accommodationSuggestion = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.accommodationSuggestion.id !== null) {
                AccommodationSuggestion.update(vm.accommodationSuggestion, onSaveSuccess, onSaveError);
            } else {
                AccommodationSuggestion.save(vm.accommodationSuggestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('autorenlesungApp:accommodationSuggestionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('AccommodationSuggestionDetailController', AccommodationSuggestionDetailController);

    AccommodationSuggestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AccommodationSuggestion'];

    function AccommodationSuggestionDetailController($scope, $rootScope, $stateParams, previousState, entity, AccommodationSuggestion) {
        var vm = this;

        vm.accommodationSuggestion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('autorenlesungApp:accommodationSuggestionUpdate', function(event, result) {
            vm.accommodationSuggestion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('AccommodationSuggestionDeleteController',AccommodationSuggestionDeleteController);

    AccommodationSuggestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'AccommodationSuggestion'];

    function AccommodationSuggestionDeleteController($uibModalInstance, entity, AccommodationSuggestion) {
        var vm = this;

        vm.accommodationSuggestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AccommodationSuggestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('accommodation-suggestion', {
            parent: 'entity',
            url: '/accommodation-suggestion',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AccommodationSuggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/accommodation-suggestion/accommodation-suggestions.html',
                    controller: 'AccommodationSuggestionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('accommodation-suggestion-detail', {
            parent: 'entity',
            url: '/accommodation-suggestion/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AccommodationSuggestion'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/accommodation-suggestion/accommodation-suggestion-detail.html',
                    controller: 'AccommodationSuggestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'AccommodationSuggestion', function($stateParams, AccommodationSuggestion) {
                    return AccommodationSuggestion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'accommodation-suggestion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('accommodation-suggestion-detail.edit', {
            parent: 'accommodation-suggestion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/accommodation-suggestion/accommodation-suggestion-dialog.html',
                    controller: 'AccommodationSuggestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccommodationSuggestion', function(AccommodationSuggestion) {
                            return AccommodationSuggestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('accommodation-suggestion.new', {
            parent: 'accommodation-suggestion',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/accommodation-suggestion/accommodation-suggestion-dialog.html',
                    controller: 'AccommodationSuggestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                email: null,
                                phone: null,
                                comment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('accommodation-suggestion', null, { reload: 'accommodation-suggestion' });
                }, function() {
                    $state.go('accommodation-suggestion');
                });
            }]
        })
        .state('accommodation-suggestion.edit', {
            parent: 'accommodation-suggestion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/accommodation-suggestion/accommodation-suggestion-dialog.html',
                    controller: 'AccommodationSuggestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccommodationSuggestion', function(AccommodationSuggestion) {
                            return AccommodationSuggestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('accommodation-suggestion', null, { reload: 'accommodation-suggestion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('accommodation-suggestion.delete', {
            parent: 'accommodation-suggestion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/accommodation-suggestion/accommodation-suggestion-delete-dialog.html',
                    controller: 'AccommodationSuggestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AccommodationSuggestion', function(AccommodationSuggestion) {
                            return AccommodationSuggestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('accommodation-suggestion', null, { reload: 'accommodation-suggestion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('autorenlesungApp')
        .factory('AccommodationSuggestion', AccommodationSuggestion);

    AccommodationSuggestion.$inject = ['$resource'];

    function AccommodationSuggestion ($resource) {
        var resourceUrl =  'api/accommodation-suggestions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('AccommodationSuggestionController', AccommodationSuggestionController);

    AccommodationSuggestionController.$inject = ['$scope', '$state', 'AccommodationSuggestion'];

    function AccommodationSuggestionController ($scope, $state, AccommodationSuggestion) {
        var vm = this;

        vm.accommodationSuggestions = [];

        loadAll();

        function loadAll() {
            AccommodationSuggestion.query(function(result) {
                vm.accommodationSuggestions = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('autorenlesungApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('autorenlesungApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('autorenlesungApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-autorenlesungApp-error');
                var entityKey = httpResponse.headers('X-autorenlesungApp-params');
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('autorenlesungApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-autorenlesungApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-autorenlesungApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('autorenlesungApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'Autorenlesung' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                if (toParams.pageTitle) {
                    titleKey = toParams.pageTitle.replace(/-/g, " ")
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('autorenlesungApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'autorenlesung'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('autorenlesungApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        //$stateProvider.state('register', {
        //    parent: 'account',
        //    url: '/register',
        //    data: {
        //        authorities: [],
        //        pageTitle: 'Registration'
        //    },
        //    views: {
        //        'content@': {
        //            templateUrl: 'app/account/register/register.html',
        //            controller: 'RegisterController',
        //            controllerAs: 'vm'
        //        }
        //    }
        //});
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('autorenlesungApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('autorenlesungApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><!-- Heading Row --><div class="row"><div class="col-md-8"><img class="img-responsive img-rounded" src="content/images/autorenlesung_resized.jpg" alt=""></div><!-- /.col-md-8 --><div class="col-md-4"><h1>Autorenlesung</h1><p>Herzlich willkommen beim Service f\xFCr Jugendkultur Eibl&Eibl! Wir bieten Ihnen als Bibliothekare, P\xE4dagogen, Veranstalter von Jugendevents die M\xF6glichkeit, bew\xE4hrte "autoren und hits f\xFCr kids" zu buchen.</p><a class="btn btn-primary btn-lg" ui-sref="authors">Zu den Autoren</a></div><!-- /.col-md-4 --></div><!-- /.row --><hr><!-- Call to Action Well --><div class="row"><div class="col-lg-12"><div class="well text-center"><i>"Bildung ist das, was \xFCbrig bleibt, wenn man alles vergessen hat, was man gelernt hat."</i> - Werner Heisenberg</div></div><!-- /.col-lg-12 --></div><!-- /.row --><!-- Content Row --><div class="row"><div class="col-md-4"><div ng-hide="vm.currentIssues.length==0"><h2>Aktuelles</h2><ul><div ng-repeat="currentIssue in vm.currentIssues track by currentIssue.id"><li><h4>{{currentIssue.title}}</h4><div ng-bind-html="currentIssue.description | unsafe"></div></li></div></ul></div></div><!-- /.col-md-4 --><!--<div class="col-md-4">--><!--<div ng-hide="true">--><!--<h2>News</h2>--><!--<p>Und hier News?</p>--><!--<a class="btn btn-default" href="#">More Info</a>--><!--</div>--><!--</div>--><div class="col-md-4"><h2>Newsletter</h2><p>Wenn Sie gerne \xFCber die neuesten Angebote und Ideen f\xFCr eine Autorenlesung informiert werden wollen, melden Sie sich f\xFCr unseren Newsletterdienst an.</p><a class="btn btn-default" ui-sref="home.newsletter">Anmelden</a></div><!-- /.col-md-4 --><div class="col-md-4"><h2>Schulausflug.at</h2><img class="img-responsive img-rounded" src="content/images/schulausflug_logo_resized.png" alt=""><p>Ihnen gef\xE4llt autorenlesung.at? Dann k\xF6nnte Sie auch schulausflug.at interessieren!</p><a target="_blank" class="btn btn-default" href="http://www.schulausflug.at">Zu Schulausflug.at</a></div><!-- /.col-md-4 --></div><!-- /.row --></div>');
$templateCache.put('app/home/newsletter-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNewsLabel">Anmeldung zum Newsletter</h4><div>Wenn Sie gerne \xFCber die neuesten Angebote und Ideen f\xFCr eine Autorenlesung informiert werden wollen, melden Sie sich f\xFCr unseren Newsletterdienst an. Wir ben\xF6tigen nur Ihre Emailadresse. Sie k\xF6nnen sich jederzeit auch wieder vom Newsletter abmelden.</div></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="email" class="form-control" name="organizerEmail" id="field_email" ng-model="vm.newsletter.email" required maxlength="255"></div><div class="form-group"><input type="checkbox" name="tos" id="field_tos" ng-model="vm.tos"><label for="field_tos">Ich bin einverstanden, dass das Service f\xFCr Jugendkultur Eibl&Eibl meine Daten laut den <a target="_blank" ui-sref="tos">Nutzungsbedingungen</a> verwenden darf.</label></div></div><div class="alert alert-danger" ng-show="vm.error">Anmeldung fehlgeschlagen. Bitte \xFCberpr\xFCfen Sie Ihre Eingaben.</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" title="{{ editForm.$invalid ? \'Leider sind Ihre Angaben nicht vollst\xE4ndig oder inkorrekt, bitte \xFCberpr\xFCfen Sie die Felder.\' : \'\'}}" ng-disabled="editForm.$invalid || vm.isSaving || !vm.tos" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Anmelden</span></button></div></form>');
$templateCache.put('app/tos/tos.html','<div><h3>Nutzungsbedingungen und Erkl\xE4rung zur Informationspflicht</h3><h4>Datenschutzerkl\xE4rung</h4>Der Schutz Ihrer pers\xF6nlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschlie\xDFlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen Datenschutzinformationen informieren wir Sie \xFCber die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.<h4>Kontakt mit uns</h4>Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und f\xFCr den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.<h4>Datenspeicherung</h4>Dar\xFCber hinaus werden zum Zweck der Vertragsabwicklung folgende Daten auch bei uns gespeichert: Name, Schulanschrift, Telefonnummern, Mailadresse, Veranstaltungsdetails, Termine. Die von Ihnen bereit gestellten Daten sind zur Vertragserf\xFCllung bzw zur Durchf\xFChrung vorvertraglicher Ma\xDFnahmen erforderlich. Ohne diese Daten k\xF6nnen wir den Vertrag mit Ihnen nicht abschlie\xDFen. Eine Daten\xFCbermittlung an Dritte erfolgt nicht, mit Ausnahme der \xDCbermittlung der Daten laut Buchungsbest\xE4tigung, die an den Autor / die Autorin weitergegeben werden. Im Falle eines Vertragsabschlusses werden s\xE4mtliche Daten aus dem Vertragsverh\xE4ltnis gespeichert.<h4>Cookies</h4>Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endger\xE4t abgelegt werden. Sie richten keinen Schaden an. Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem Endger\xE4t gespeichert, bis Sie diese l\xF6schen. Sie erm\xF6glichen es uns, Ihren Browser beim n\xE4chsten Besuch wiederzuerkennen. Wenn Sie dies nicht w\xFCnschen, so k\xF6nnen Sie Ihren Browser so einrichten, dass er Sie \xFCber das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben. Bei der Deaktivierung von Cookies kann die Funktionalit\xE4t unserer Website eingeschr\xE4nkt sein.<h4>Web-Analyse</h4>Unsere Website verwendet Funktionen des Webanalysedienstes google analytics, ein Dienst der Google Inc, 1600 Amphitheatre Parkway Mountain View, CA 94043, USA; die Daten werden an ein au\xDFereurop\xE4isches Drittland \xFCbertragen. Dazu werden Cookies verwendet, die eine Analyse der Benutzung der Website durch Ihre Benutzer erm\xF6glicht. Die dadurch erzeugten Informationen werden auf den Server des Anbieters \xFCbertragen und dort gespeichert. Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des \xA7 96 Abs 3 TKG sowie des Art 6 Abs 1 lit a (Einwilligung) und/oder f (berechtigtes Interesse) der DSGVO.<h4>Newsletter</h4>Sie haben die M\xF6glichkeit, \xFCber unsere Website unseren Newsletter zu abonnieren. Hierf\xFCr ben\xF6tigen wir Ihre E-Mail-Adresse und ihre Erkl\xE4rung, dass Sie mit dem Bezug des Newsletters einverstanden sind. Das Abo des Newsletters k\xF6nnen Sie jederzeit stornieren. Senden Sie Ihre Stornierung bitte an folgende E-Mail-Adresse: f.eibl@autorenlesung.at. Wir l\xF6schen anschlie\xDFend umgehend Ihre Daten im Zusammenhang mit dem Newsletter-Versand.<h4>Ihre Rechte</h4>Ihnen stehen grunds\xE4tzlich die Rechte auf Auskunft, Berichtigung, L\xF6schung, Einschr\xE4nkung, Daten\xFCbertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verst\xF6\xDFt oder Ihre datenschutzrechtlichen Anspr\xFCche sonst in einer Weise verletzt worden sind, k\xF6nnen Sie sich bei der Aufsichtsbeh\xF6rde beschweren. In \xD6sterreich ist dies die Datenschutzbeh\xF6rde.\xA0 Sie erreichen uns unter folgenden Kontaktdaten:<br><br>Service f\xFCr Jugendkultur Eibl&Eibl, 0043 664 521 80 88; f.eibl@autorenlesung.at</div>');
$templateCache.put('app/user-author/author-detail.html','<div><div ng-bind-html="vm.artist.content | unsafe"></div><div ng-repeat="event in vm.artist.events track by event.id"><div ng-bind-html="event.content | unsafe"></div><br><button type="submit" ui-sref="user-price-inquiry({id: event.id})" class="btn btn-info"><span class="glyphicon glyphicon-euro"></span>&nbsp;<span> Preisanfrage</span></button> <button type="button" ui-sref="user-reservation({id: event.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span> Reservierung</span></button></div><div id="placement_boxes"><div ng-repeat="placement in vm.artist.placements track by placement.id"><a target="_blank" title="{{placement.title}}" href="{{placement.url}}"><img data-ng-src="{{\'data:\' + placement.imageContentType + \';base64,\' + placement.image}}"></a><p><a target="_blank" title="{{placement.title}}" href="{{placement.url}}">{{placement.title}}</a></p></div></div></div>');
$templateCache.put('app/user-author/authors.html','<div ng-if="vm.authors.length>0"><div class="image-container" ng-cloak><div class="filter-container">Alter der Sch\xFCler/Zielgruppe <input type="number" name="age" ng-model-options="{debounce: 500}" ng-model="vm.age" min="0" placeholder=\'z.B. "12"\'></div><div ng-repeat="author in vm.authors track by author.id" class="col-lg-3 col-sm-4 col-xs-6" align="center"><div ng-if="author.image" class="artist-box"><a title="{{author.title}}" ui-sref="author-detail({id: author.id, pageTitle: vm.urlify(author.title)})"><img class="img-responsive img-rounded" data-ng-src="{{\'data:\' + author.imageContentType + \';base64,\' + author.image}}"></a><p><a title="{{author.title}}" ui-sref="author-detail({id: author.id, pageTitle: author.title})">{{author.title}}</a></p></div></div></div><div class="image-container" ng-cloak ng-if="vm.hits.length>0"><h3 style="margin: 20px">Weitere Hits...</h3><div ng-repeat="hit in vm.hits track by hit.id" class="col-lg-3 col-sm-4 col-xs-6" align="center"><div ng-if="hit.image" class="artist-box"><a title="{{hit.title}}" ui-sref="hit-detail({id: hit.id, pageTitle: vm.urlify(hit.title)})"><img class="img-responsive img-rounded" data-ng-src="{{\'data:\' + hit.imageContentType + \';base64,\' + hit.image}}"></a><p><a title="{{hit.title}}" ui-sref="hit-detail({id: hit.id, pageTitle: vm.urlify(hit.title)})">{{hit.title}}</a></p></div></div></div></div>');
$templateCache.put('app/user-hit/hit-detail.html','<div><div ng-bind-html="vm.artist.content | unsafe"></div><div ng-repeat="event in vm.artist.events track by event.id"><div ng-bind-html="event.content | unsafe"></div><br><button type="submit" ui-sref="user-price-inquiry({id: event.id})" class="btn btn-info"><span class="glyphicon glyphicon-euro"></span>&nbsp;<span> Preisanfrage</span></button> <button type="button" ui-sref="user-reservation({id: event.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span> Reservierung</span></button></div><div id="placement_boxes"><div ng-repeat="placement in vm.artist.placements track by placement.id"><a target="_blank" title="{{placement.title}}" href="{{placement.url}}"><img data-ng-src="{{\'data:\' + placement.imageContentType + \';base64,\' + placement.image}}"></a><p><a target="_blank" title="{{placement.title}}" href="{{placement.url}}">{{placement.title}}</a></p></div></div></div>');
$templateCache.put('app/user-hit/hits.html','<div class="image-container" ng-cloak><div class="filter-container">Alter der Sch\xFCler/Zielgruppe <input type="number" name="age" ng-model-options="{debounce: 500}" ng-model="vm.age" min="0" placeholder=\'z.B. "12"\'></div><div ng-repeat="hit in vm.hits track by hit.id" class="col-lg-3 col-sm-4 col-xs-6" align="center"><div ng-if="hit.image" class="artist-box"><a title="{{hit.title}}" ui-sref="hit-detail({id: hit.id, pageTitle: vm.urlify(hit.title)})"><img class="img-responsive img-rounded" data-ng-src="{{\'data:\' + hit.imageContentType + \';base64,\' + hit.image}}"></a><p><a title="{{hit.title}}" ui-sref="hit-detail({id: hit.id, pageTitle: vm.urlify(hit.title)})">{{hit.title}}</a></p></div></div></div>');
$templateCache.put('app/user-price-inquiry/user-price-inquiry-success.html','<h2>Danke f\xFCr Ihre Preisanfrage!</h2><p>Sie erhalten in den n\xE4chsten Minuten eine Mailantwort mit den Tarifen, die evtl. auch im Spamordner landen k\xF6nnte. Bitte kontaktieren Sie uns per Mail, wenn bei Ihnen keine Preisanfrage einlangt.</p><p>Bitte beachten Sie, dass wir auf Preisanfragen \xFCblicherweise nicht reagieren.</p><br><p>Fritz Eibl, Service f\xFCr Jugendkultur</p>');
$templateCache.put('app/user-price-inquiry/user-price-inquiry.html','<div><h2>Preisanfrage f\xFCr die Veranstaltung \'{{vm.event.title}}\' von \'{{vm.artist.title}}\'</h2></div><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="field_organizationName">Name der Schule / Bibliothek bzw. des Veranstalters</label><input type="text" class="form-control" name="organizationName" id="field_organizationName" ng-model="vm.priceInquiry.organizationName" maxlength="255" required><div ng-show="editForm.organizationName.$invalid"><p class="help-block" ng-show="editForm.organizationName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_organizerName">Name des Anfragenden</label><input type="text" class="form-control" name="organizerName" id="field_organizerName" ng-model="vm.priceInquiry.organizerName" maxlength="255" required><div ng-show="editForm.organizerName.$invalid"><p class="help-block" ng-show="editForm.organizerName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_organizerEmail">Email-Adresse</label><input type="email" class="form-control" name="organizerEmail" id="field_organizerEmail" ng-model="vm.priceInquiry.organizerEmail" maxlength="255" required><div ng-show="editForm.organizerEmail.$invalid"><p class="help-block" ng-show="editForm.organizerEmail.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_comment">Fragen</label><textarea class="form-control" name="comment" id="field_comment" ng-model="vm.priceInquiry.comment"> </textarea></div><div class="form-group"><input type="checkbox" name="tos" id="field_tos" ng-model="vm.tos"><label for="field_tos">Ich bin einverstanden, dass das Service f\xFCr Jugendkultur Eibl&Eibl meine Daten laut den <a target="_blank" ui-sref="tos">Nutzungsbedingungen</a> verwenden darf.</label></div><div class="alert alert-danger" ng-show="vm.error">Preisanfrage fehlgeschlagen. Bitte \xFCberpr\xFCfen Sie Ihre Eingaben.</div><div class="tooltip-wrapper" data-title="Dieser Link f\xFChrt zu Google"><button type="submit" title="{{ editForm.$invalid ? \'Leider sind Ihre Angaben nicht vollst\xE4ndig oder inkorrekt, bitte \xFCberpr\xFCfen Sie die Felder.\' : \'\'}}" ng-disabled="editForm.$invalid || vm.isSaving || !vm.tos" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Absenden</span></button></div></form>');
$templateCache.put('app/user-reservation/user-reservation-success.html','<h2>Danke f\xFCr Ihre Reservierung!</h2><p>Sie erhalten in den n\xE4chsten Minuten eine Kopie Ihrer Reservierung per Mail, die evtl. auch im Spamordner landen k\xF6nnte. Bitte kontaktieren Sie uns per Mail, wenn bei Ihnen keine Reservierung einlangt.</p><p>Ihre Reservierung wird von uns w\xE4hrend der Schulzeit innerhalb von vier Schultagen bearbeitet.<br>Sie erhalten eine Mailantwort oder wir rufen Sie an.</p><br><p>Fritz Eibl, Service f\xFCr Jugendkultur</p>');
$templateCache.put('app/user-reservation/user-reservation.html','<div><h2>Reservierung der Veranstaltung \'{{vm.event.title}}\' von \'{{vm.artist.title}}\'</h2></div><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="field_organizationName">Name der Schule / Bibliothek bzw. des Veranstalters</label><input type="text" class="form-control" name="organizationName" id="field_organizationName" ng-model="vm.reservation.organizationName" required maxlength="255"><div ng-show="editForm.organizationName.$invalid"><p class="help-block" ng-show="editForm.organizationName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_organizationAddress">Adresse der Schule / Bibliothek bzw. des Veranstalters</label><input type="text" class="form-control" name="organizationAddress" id="field_organizationAddress" ng-model="vm.reservation.organizationAddress" required maxlength="255"><div ng-show="editForm.organizationAddress.$invalid"><p class="help-block" ng-show="editForm.organizationAddress.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_organizationPhone">Telefonnummer der Schule / Bibliothek bzw. des Veranstalters</label><input type="text" class="form-control" name="organizationPhone" id="field_organizationPhone" ng-model="vm.reservation.organizationPhone" required maxlength="255"><div ng-show="editForm.organizationPhone.$invalid"><p class="help-block" ng-show="editForm.organizationPhone.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_organizerName">Name des Verantwortlichen</label><input type="text" class="form-control" name="organizerName" id="field_organizerName" ng-model="vm.reservation.organizerName" required maxlength="255"><div ng-show="editForm.organizerName.$invalid"><p class="help-block" ng-show="editForm.organizerName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_organizerPhone">Private Erreichbarkeit - Tel.</label><input type="text" class="form-control" name="organizerPhone" id="field_organizerPhone" ng-model="vm.reservation.organizerPhone" required maxlength="255"><div ng-show="editForm.organizerPhone.$invalid"><p class="help-block" ng-show="editForm.organizerPhone.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_organizerEmail">Private Erreichbarkeit - Email</label><input type="email" class="form-control" name="organizerEmail" id="field_organizerEmail" ng-model="vm.reservation.organizerEmail" required maxlength="255"><div ng-show="editForm.organizerEmail.$invalid"><p class="help-block" ng-show="editForm.organizerEmail.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_desiredDate">Wunschtermin</label><div class="input-group"><input id="field_desiredDate" type="text" class="form-control" name="desiredDate" readonly="readonly" style="background-color:White" placeholder="Bitte hier klicken um Termin auszuw\xE4hlen" ng-click="vm.openCalendar(\'desiredDate\')" datetime-picker="dd.MM.yyyy" enable-time="false" ng-model="vm.reservation.desiredDate" is-open="vm.datePickerOpenStatus.desiredDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'desiredDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_alternateDate">Ersatztermin (bei Lesereisen nicht notwendig)</label><div class="input-group"><input id="field_alternateDate" type="text" class="form-control" name="alternateDate" readonly="readonly" style="background-color:White" placeholder="Bitte hier klicken um Termin auszuw\xE4hlen" ng-click="vm.openCalendar(\'alternateDate\')" datetime-picker="dd.MM.yyyy" enable-time="false" ng-model="vm.reservation.alternateDate" is-open="vm.datePickerOpenStatus.alternateDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'alternateDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_lessonStart">Unterrichtsbeginn</label><div class="input-group"><select name="lessonStart" id="field_lessonStart" ng-options="time as (time | date:\'HH:mm\') for time in vm.timesLessonStart" ng-model="vm.reservation.lessonStart" required></select></div><div ng-show="editForm.lessonStart.$invalid"><p class="help-block" ng-show="editForm.lessonStart.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_breakFrom">Beginn der gro\xDFen Pause</label><div class="input-group"><select name="breakFrom" id="field_breakFrom" ng-options="time as (time | date:\'HH:mm\') for time in vm.timesBreakFrom" ng-model="vm.reservation.breakFrom" required></select></div><div ng-show="editForm.breakFrom.$invalid"><p class="help-block" ng-show="editForm.breakFrom.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_breakTo">Ende der gro\xDFen Pause</label><div class="input-group"><select name="breakTo" id="field_breakTo" ng-options="time as (time | date:\'HH:mm\') for time in vm.timesBreakTo" ng-model="vm.reservation.breakTo" required></select></div><div ng-show="editForm.breakTo.$invalid"><p class="help-block" ng-show="editForm.breakTo.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_numberOfAttendees">Ungef\xE4hre Gesamtteilnehmerzahl</label><input type="number" class="form-control" name="numberOfAttendees" id="field_numberOfAttendees" ng-model="vm.reservation.numberOfAttendees" required><div ng-show="editForm.numberOfAttendees.$invalid"><p class="help-block" ng-show="editForm.numberOfAttendees.$error.required">Dieses Feld ist verpflichtend.</p><p class="help-block" ng-show="editForm.numberOfAttendees.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_attendeeDescription">Alter der Sch\xFCler / Schulstufe</label><input type="text" class="form-control" name="attendeeDescription" id="field_attendeeDescription" ng-model="vm.reservation.attendeeDescription" required maxlength="255"><div ng-show="editForm.attendeeDescription.$invalid"><p class="help-block" ng-show="editForm.attendeeDescription.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_numberOfEvents">Anzahl der Lesungen oder Veranstaltungen</label><input type="number" class="form-control" name="numberOfEvents" id="field_numberOfEvents" ng-model="vm.reservation.numberOfEvents" required><div ng-show="editForm.numberOfEvents.$invalid"><p class="help-block" ng-show="editForm.numberOfEvents.$error.required">Dieses Feld ist verpflichtend.</p><p class="help-block" ng-show="editForm.numberOfEvents.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_comment">Fragen</label><textarea class="form-control" name="comment" id="field_comment" ng-model="vm.reservation.comment"> </textarea></div><div ng-if="vm.event.accommodationRequest"><h4>{{vm.artist.title}} ben\xF6tigt bei dieser Veranstaltung ein Quartier. Wir bitten Sie nach M\xF6glichkeit um einen Vorschlag</h4><div class="form-group"><label class="control-label" for="field_name">Quartier - Name und Adresse</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.accommodationSuggestion.name" maxlength="255"></div><div class="form-group"><label class="control-label" for="field_email" ng-class="{red_text: editForm.email.$invalid}">Quartier - Email</label><input type="email" class="form-control" ng-class="{red: editForm.email.$invalid}" name="email" id="field_email" ng-model="vm.accommodationSuggestion.email" maxlength="255"></div><div class="form-group"><label class="control-label" for="field_phone">Quartier - Telefon</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.accommodationSuggestion.phone" maxlength="255"></div><div class="form-group"><label class="control-label" for="field_acc_comment">Quartier - Anmerkung</label><textarea class="form-control" name="comment" id="field_acc_comment" ng-model="vm.accommodationSuggestion.comment"> </textarea></div></div><div class="form-group"><input type="checkbox" name="tos" id="field_tos" ng-model="vm.tos"><label for="field_tos">Ich bin einverstanden, dass das Service f\xFCr Jugendkultur Eibl&Eibl meine Daten laut den <a target="_blank" ui-sref="tos">Nutzungsbedingungen</a> verwenden darf.</label></div><div class="alert alert-danger" ng-show="vm.error">Reservierung fehlgeschlagen. Bitte \xFCberpr\xFCfen Sie Ihre Eingaben.</div><button type="submit" title="{{ editForm.$invalid ? \'Leider sind Ihre Angaben nicht vollst\xE4ndig oder inkorrekt, bitte \xFCberpr\xFCfen Sie die Felder.\' : \'\'}}" ng-disabled="editForm.$invalid || vm.isSaving || !vm.tos" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Reservieren</span></button></form>');
$templateCache.put('app/user-static-pages/info.html','<div ng-cloak><div ng-bind-html="vm.staticPage.content | unsafe"></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><div class="alert alert-success" ng-show="vm.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></form><p></p><div class="alert alert-warning">If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" style="cursor: pointer">Activated</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Anmelden</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Anmelden</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError"><strong>Fehler beim Anmelden!</strong></div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username">Benutzername</label><input type="text" class="form-control" id="username" placeholder="Benutzername" ng-model="vm.username"></div><div class="form-group"><label for="password">Passwort</label><input type="password" class="form-control" id="password" placeholder="Passwort" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span>Anmeldeinformationen merken</span></label></div><button type="submit" class="btn btn-primary">Anmelden</button></form><!--<div class="alert alert-warning">--><!--You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>--><!--</div>--></div></div></div>');
$templateCache.put('app/entities/accommodation-suggestion/accommodation-suggestion-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.accommodationSuggestion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Accommodation Suggestion?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/accommodation-suggestion/accommodation-suggestion-detail.html','<div><h2><span>Accommodation Suggestion</span> {{vm.accommodationSuggestion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.accommodationSuggestion.name}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.accommodationSuggestion.email}}</span></dd><dt><span>Phone</span></dt><dd><span>{{vm.accommodationSuggestion.phone}}</span></dd><dt><span>Comment</span></dt><dd><span>{{vm.accommodationSuggestion.comment}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="accommodation-suggestion-detail.edit({id:vm.accommodationSuggestion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/accommodation-suggestion/accommodation-suggestion-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAccommodationSuggestionLabel">Create or edit a Accommodation Suggestion</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.accommodationSuggestion.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.accommodationSuggestion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.accommodationSuggestion.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.accommodationSuggestion.email"></div><div class="form-group"><label class="control-label" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.accommodationSuggestion.phone"></div><div class="form-group"><label class="control-label" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.accommodationSuggestion.comment"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/accommodation-suggestion/accommodation-suggestions.html','<div><h2>Accommodation Suggestions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="accommodation-suggestion.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Accommodation Suggestion</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Name</span></th><th><span>Email</span></th><th><span>Phone</span></th><th><span>Comment</span></th><th></th></tr></thead><tbody><tr ng-repeat="accommodationSuggestion in vm.accommodationSuggestions track by accommodationSuggestion.id"><td><a ui-sref="accommodation-suggestion-detail({id:accommodationSuggestion.id})">{{accommodationSuggestion.id}}</a></td><td>{{accommodationSuggestion.name}}</td><td>{{accommodationSuggestion.email}}</td><td>{{accommodationSuggestion.phone}}</td><td>{{accommodationSuggestion.comment}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="accommodation-suggestion-detail({id:accommodationSuggestion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="accommodation-suggestion.edit({id:accommodationSuggestion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="accommodation-suggestion.delete({id:accommodationSuggestion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/artist/artist-content.html','<div><h2>{{vm.artist.title}} - Seiteninhalt</h2><form name="contentForm" role="form" novalidate ng-submit="vm.save()" show-validation><p>Dies ist der Seiteninhalt, der f\xFCr die Besucher deiner Seite sichtbar ist.</p><textarea ui-tinymce="tinymceOptions" ng-model="vm.artist.content"></textarea><hr><button ui-sref="artist-detail({id:vm.artist.id})" class="btn btn-info"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span> Abbrechen</span></button> <button type="submit" ng-disabled="vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></form></div>');
$templateCache.put('app/entities/artist/artist-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.artist.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diesen K\xFCnstler wirklich l\xF6schen? Es werden dadurch auch alle Veranstaltungen sowie Reservierungen des K\xFCnstlers gel\xF6scht.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/artist/artist-detail.html','<div><h2>{{vm.artist.title}}</h2><button type="submit" ui-sref="artist" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="artist-detail.edit({id:vm.artist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Bearbeiten</span></button> <button type="button" ui-sref="artist-content({id:vm.artist.id})" class="btn"><span class="glyphicon glyphicon-text-size"></span> <span class="hidden-xs hidden-sm">Seiteninhalt</span></button><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Typ</span></dt><dd><span>{{vm.artist.type | type}}</span></dd><dt><span>Titel</span></dt><dd><span>{{vm.artist.title}}</span></dd><dt><span>Geschlecht</span></dt><dd><span>{{vm.artist.gender | gender}}</span></dd><dt><span>Vorname</span></dt><dd><span>{{vm.artist.firstName}}</span></dd><dt><span>Nachname</span></dt><dd><span>{{vm.artist.lastName}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.artist.email}}</span></dd><dt><span>Telefon</span></dt><dd><span>{{vm.artist.phoneNumber}}</span></dd><dt><span>Adresse</span></dt><dd><span>{{vm.artist.address}}</span></dd><dd><div ng-if="vm.artist.image"><a ng-click="vm.openFile(vm.artist.imageContentType, vm.artist.image)"><img data-ng-src="{{\'data:\' + vm.artist.imageContentType + \';base64,\' + vm.artist.image}}" style="max-width: 100%"> </a>{{vm.artist.imageContentType}}, {{vm.byteSize(vm.artist.image)}}</div></dd><dt><span>Position</span></dt><dd><span>{{vm.artist.position}}</span></dd><dt><span>Sichtbar</span></dt><dd><span>{{vm.artist.active | checkmark}}</span></dd><dt><span>Jahrestarif Homepage</span></dt><dd><span>{{vm.artist.annualFee}}</span></dd><dt><span>Preisvereinbarung</span></dt><dd><span>{{vm.artist.priceAgreement}}</span></dd></dl><h3>Veranstaltungen und Preisinformation</h3><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button type="submit" class="btn btn-primary" ui-sref="artist-detail.new-event({id:vm.artist.id})"><span class="glyphicon glyphicon-plus"></span> <span>Neue Veranstaltung erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="title"><span>Titel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="artistContact"><span>K\xFCnstlerkontakt</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="accommodationRequest"><span>Quartierwunsch</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span>Sichtbar</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tr ng-repeat="event in vm.artist.events track by event.id"><td>{{event.title}}</td><td>{{event.artistContact | checkmark}}</td><td>{{event.accommodationRequest | checkmark}}</td><td>{{event.active | checkmark}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="event-detail({id:event.artistId, event_id:event.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="artist-detail.edit-event({id:event.artistId, event_id:event.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="artist-detail.delete-event({id:event.artistId, event_id:event.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></table></div><h3>Werbungen</h3><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button type="submit" class="btn btn-primary" ui-sref="artist-detail.new-placement({id:vm.artist.id})"><span class="glyphicon glyphicon-plus"></span> <span>Neue Werbung erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Titel</span></th><th><span>Beschreibung</span></th><th><span>Url</span></th><th><span>Bild</span></th><th></th></tr></thead><tbody><tr ng-repeat="placement in vm.artist.placements track by placement.id"><td>{{placement.title}}</td><td>{{placement.description}}</td><td>{{placement.url}}</td><td><a ng-if="placement.image" ng-click="vm.openFile(placement.imageContentType, placement.image)"><img data-ng-src="{{\'data:\' + placement.imageContentType + \';base64,\' + placement.image}}" style="max-height: 30px"> </a><span ng-if="placement.image">{{placement.imageContentType}}, {{vm.byteSize(placement.image)}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="placement-detail({id:placement.artistId, placement_id:placement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="artist-detail.edit-placement({id:placement.artistId, placement_id:placement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="artist-detail.delete-placement({id:placement.artistId, placement_id:placement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/artist/artist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myArtistLabel">K\xFCnstler erstellen oder bearbeiten</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_type">Typ</label><select class="form-control" name="type" ng-model="vm.artist.type" id="field_type"><option value="AUTHOR">Autor</option><option value="HIT">Hit</option></select></div><div class="form-group"><label class="control-label" for="field_title">Titel</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.artist.title" required maxlength="255"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_gender">Geschlecht</label><select class="form-control" name="gender" ng-model="vm.artist.gender" id="field_gender" required><option value="MALE">M\xE4nnlich</option><option value="FEMALE">Weiblich</option></select><div ng-show="editForm.gender.$invalid"><p class="help-block" ng-show="editForm.gender.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_firstName">Vorname</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.artist.firstName" maxlength="255"></div><div class="form-group"><label class="control-label" for="field_lastName">Nachname</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.artist.lastName" maxlength="255"></div><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.artist.email" maxlength="255"></div><div class="form-group"><label class="control-label" for="field_phoneNumber">Telefon</label><input type="text" class="form-control" name="phoneNumber" id="field_phoneNumber" ng-model="vm.artist.phoneNumber" maxlength="255"></div><div class="form-group"><label class="control-label" for="field_address">Adresse</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.artist.address" maxlength="255"></div><div class="form-group" ngf-drop ngf-change="vm.setImage($file, vm.artist)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_image">Bild</label><div><img data-ng-src="{{\'data:\' + vm.artist.imageContentType + \';base64,\' + vm.artist.image}}" style="max-height: 100px" ng-if="vm.artist.image"><div ng-if="vm.artist.image" class="help-block clearfix"><span class="pull-left">{{vm.artist.imageContentType}}, {{vm.byteSize(vm.artist.image)}}</span> <button type="button" ng-click="vm.artist.image=null;vm.artist.imageContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImage($file, vm.artist)" accept="image/*">Bild hinzuf\xFCgen</button></div><input type="hidden" class="form-control" name="image" id="field_image" ng-model="vm.artist.image" required> <input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType" ng-model="vm.artist.imageContentType"><div ng-show="editForm.image.$invalid"><p class="help-block" ng-show="editForm.image.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.artist.position"></div><div class="form-group"><label class="control-label" for="field_active">Sichtbar</label><input type="checkbox" class="form-control" name="active" id="field_active" ng-model="vm.artist.active" ng-init="vm.artist.active = true"></div><div class="form-group"><label class="control-label" for="field_annualFee">Jahrestarif Homepage</label><input type="text" class="form-control" name="active" id="field_annualFee" ng-model="vm.artist.annualFee"></div><div class="form-group"><label class="control-label" for="field_priceAgreement">Preisvereinbarung</label><input type="text" class="form-control" name="active" id="field_priceAgreement" ng-model="vm.artist.priceAgreement"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/artist/artists.html','<div><h2>K\xFCnstler</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="artist.new"><span class="glyphicon glyphicon-plus"></span> <span>Neuen K\xFCnstler erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="type"><span>Typ</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span>Titel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span>Vorname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Nachname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneNumber"><span>Telefon</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="position"><span>Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span>Sichtbar</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="artist in vm.artists track by artist.id"><td>{{artist.type | type}}</td><td>{{artist.title}}</td><td>{{artist.firstName}}</td><td>{{artist.lastName}}</td><td>{{artist.email}}</td><td>{{artist.phoneNumber}}</td><td>{{artist.position}}</td><td>{{artist.active | checkmark}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="artist-detail({id:artist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="artist.edit({id:artist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="artist.delete({id:artist.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/current-issue/current-issue-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.currentIssue.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diesen Eintrag wirklich l\xF6schen?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/current-issue/current-issue-detail.html','<div><h2><span>Current Issue</span> {{vm.currentIssue.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Titel</span></dt><dd><span>{{vm.currentIssue.title}}</span></dd><dt><span>Beschreibung</span></dt><dd><div ng-bind-html="vm.currentIssue.description | unsafe"></div></dd><dt><span>Startdatum</span></dt><dd><span>{{vm.currentIssue.startDate | date:\'medium\'}}</span></dd><dt><span>Enddatum</span></dt><dd><span>{{vm.currentIssue.endDate | date:\'medium\'}}</span></dd><dt><span>Sichtbar</span></dt><dd><span>{{vm.currentIssue.active | checkmark}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="current-issue-detail.edit({id:vm.currentIssue.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Bearbeiten</span></button></div>');
$templateCache.put('app/entities/current-issue/current-issue-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCurrentIssueLabel">Aktuelles erstellen oder bearbeiten</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_title">Titel</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.currentIssue.title" maxlength="255" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div><label>Beschreibung</label><textarea ui-tinymce="tinymceOptions" ng-model="vm.currentIssue.description"></textarea></div><div class="form-group"><label class="control-label" for="field_startDate">Startdatum</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.currentIssue.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_endDate">Enddatum</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datetime-picker="{{dateformat}}" timepicker-options="{showMeridian: false}" ng-model="vm.currentIssue.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_active">Sichtbar</label><input type="checkbox" class="form-control" name="active" id="field_active" ng-model="vm.currentIssue.active"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/current-issue/current-issues.html','<div><h2>Aktuelles</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="current-issue.new"><span class="glyphicon glyphicon-plus"></span> <span>Neues Aktuelles erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="title"><span>Titel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span>Beschreibung</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate"><span>Startdatum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endDate"><span>Enddatum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span>Sichtbar</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="currentIssue in vm.currentIssues track by currentIssue.id"><td>{{currentIssue.title}}</td><td ng-bind-html="currentIssue.description"></td><td>{{currentIssue.startDate | date:\'medium\'}}</td><td>{{currentIssue.endDate | date:\'medium\'}}</td><td>{{currentIssue.active | checkmark}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="current-issue-detail({id:currentIssue.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="current-issue.edit({id:currentIssue.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="current-issue.delete({id:currentIssue.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/event/event-content.html','<div><h2>{{vm.artist.title}} - {{vm.event.title}} - Seiteninhalt</h2><form name="contentForm" role="form" novalidate ng-submit="vm.save()" show-validation><p>Dies ist der Seiteninhalt, der f\xFCr die Besucher deiner Seite sichtbar ist.</p><textarea ui-tinymce="tinymceOptions" ng-model="vm.event.content"></textarea><hr><button ui-sref="event-detail({id:vm.event.artistId, event_id:vm.event.id})" class="btn btn-info"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span> Abbrechen</span></button> <button type="submit" ng-disabled="vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></form></div>');
$templateCache.put('app/entities/event/event-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.event.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diese Veranstaltung wirklich l\xF6schen? Es werden dadurch auch alle Reservierungen des K\xFCnstlers gel\xF6scht.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/event/event-detail.html','<div><h2><span>{{vm.artist.title}} - {{vm.event.title}}</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Titel</span></dt><dd><span>{{vm.event.title}}</span></dd><dt><span>K\xFCnstlerkontakt</span></dt><dd><span>{{vm.event.artistContact | checkmark}}</span></dd><dt><span>Quartierwunsch</span></dt><dd><span>{{vm.event.accommodationRequest | checkmark}}</span></dd><dt><span>Preisinformation</span></dt><dd><div ng-bind-html="vm.event.priceInformationText | unsafe"></div></dd><dt><span>Minimalalter</span></dt><dd><span>{{vm.event.minAge}}</span></dd><dt><span>Maximalalter</span></dt><dd><span>{{vm.event.maxAge}}</span></dd><dt><span>Position</span></dt><dd><span>{{vm.event.position}}</span></dd><dt><span>Sichtbar</span></dt><dd><span>{{vm.event.active | checkmark}}</span></dd></dl><button type="submit" ui-sref="artist-detail({id:vm.event.artistId})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="event-detail.edit({id:vm.event.artistId, event_id:vm.event.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Bearbeiten</span></button> <button type="button" ui-sref="event-content({id:vm.event.artistId, event_id: vm.event.id})" class="btn"><span class="glyphicon glyphicon-text-size"></span> <span class="hidden-xs hidden-sm">Seiteninhalt</span></button></div>');
$templateCache.put('app/entities/event/event-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEventLabel">Veranstaltung erstellen oder bearbeiten</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.event.title" required maxlength="255"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_artistContact">K\xFCnstlerkontakt</label><input type="checkbox" class="form-control" name="artistContact" id="field_artistContact" ng-model="vm.event.artistContact"></div><div class="form-group"><label class="control-label" for="field_accommodationRequest">Quartierwunsch</label><input type="checkbox" class="form-control" name="accommodationRequest" id="field_accommodationRequest" ng-model="vm.event.accommodationRequest"></div><div><label>Preisinformation (Emailtext)</label><textarea ui-tinymce="tinymceOptions" ng-model="vm.event.priceInformationText" style="height:50px"></textarea></div><div class="form-group"><label class="control-label" for="field_minAge">Minimalalter</label><input type="number" class="form-control" name="minAge" id="field_minAge" ng-model="vm.event.minAge"></div><div class="form-group"><label class="control-label" for="field_maxAge">Maximalalter</label><input type="number" class="form-control" name="maxAge" id="field_maxAge" ng-model="vm.event.maxAge"></div><div class="form-group"><label class="control-label" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.event.position"></div><div class="form-group"><label class="control-label" for="field_active">Sichtbar</label><input type="checkbox" class="form-control" name="active" id="field_active" ng-model="vm.event.active"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/event/events.html','<div><h2>Events</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="event.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Event</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span>Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span>Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="artistContact"><span>Artist Contact</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="accommodationRequest"><span>Accommodation Request</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="position"><span>Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span>Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="artistId"><span>Artist</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="event in vm.events track by event.id"><td><a ui-sref="event-detail({id:event.id})">{{event.id}}</a></td><td>{{event.title}}</td><td>{{event.content}}</td><td>{{event.artistContact}}</td><td>{{event.accommodationRequest}}</td><td>{{event.position}}</td><td>{{event.active}}</td><td><a ui-sref="artist-detail({id:event.artistId})">{{event.artistId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="event-detail({id:event.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="event.edit({id:event.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="event.delete({id:event.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/news/news-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.news.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this News?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/news/news-detail.html','<div><h2><span>News</span> {{vm.news.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Title</span></dt><dd><span>{{vm.news.title}}</span></dd><dt><span>Content</span></dt><dd><span>{{vm.news.content}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="news-detail.edit({id:vm.news.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/news/news-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNewsLabel">Create or edit a News</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.news.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.news.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.news.title" required maxlength="255"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_content">Content</label><textarea class="form-control" name="content" id="field_content" ng-model="vm.news.content"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/news/news.html','<div><h2>News</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="news.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new News</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span>Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span>Content</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="news in vm.news track by news.id"><td><a ui-sref="news-detail({id:news.id})">{{news.id}}</a></td><td>{{news.title}}</td><td>{{news.content}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="news-detail({id:news.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="news.edit({id:news.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="news.delete({id:news.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/placement/placement-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.placement.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen Best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diese Werbung wirklich l\xF6schen?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/placement/placement-detail.html','<div><h2><span>{{vm.artist.title}} - {{vm.placement.title}}</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Titel</span></dt><dd><span>{{vm.placement.title}}</span></dd><dt><span>Beschreibung</span></dt><dd><span>{{vm.placement.description}}</span></dd><dt><span>Url</span></dt><dd><span>{{vm.placement.url}}</span></dd><dt><span>Bild</span></dt><dd><div ng-if="vm.placement.image"><a ng-click="vm.openFile(vm.placement.imageContentType, vm.placement.image)"><img data-ng-src="{{\'data:\' + vm.placement.imageContentType + \';base64,\' + vm.placement.image}}" style="max-width: 100%"> </a>{{vm.placement.imageContentType}}, {{vm.byteSize(vm.placement.image)}}</div></dd></dl><button type="submit" ui-sref="artist-detail({id:vm.placement.artistId})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="placement-detail.edit({id:vm.placement.artistId, placement_id:vm.placement.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Bearbeiten</span></button></div>');
$templateCache.put('app/entities/placement/placement-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPlacementLabel">Werbung erstellen oder bearbeiten</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_title">Titel</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.placement.title" required maxlength="255"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Beschreibung</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.placement.description" maxlength="255"></div><div class="form-group"><label class="control-label" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.placement.url"></div><div class="form-group" ngf-drop ngf-change="vm.setImage($file, vm.placement)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_image">Bild</label><div><img data-ng-src="{{\'data:\' + vm.placement.imageContentType + \';base64,\' + vm.placement.image}}" style="max-height: 100px" ng-if="vm.placement.image"><div ng-if="vm.placement.image" class="help-block clearfix"><span class="pull-left">{{vm.placement.imageContentType}}, {{vm.byteSize(vm.placement.image)}}</span> <button type="button" ng-click="vm.placement.image=null;vm.placement.imageContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImage($file, vm.placement)" accept="image/*">Bild hinzuf\xFCgen</button></div><input type="hidden" class="form-control" name="image" id="field_image" ng-model="vm.placement.image" required> <input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType" ng-model="vm.placement.imageContentType"><div ng-show="editForm.image.$invalid"><p class="help-block" ng-show="editForm.image.$error.required">Dieses Feld ist verpflichtend.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/placement/placements.html','<div><h2>Placements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="placement.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Placement</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Title</span></th><th><span>Description</span></th><th><span>Url</span></th><th><span>Image</span></th><th><span>Artist</span></th><th></th></tr></thead><tbody><tr ng-repeat="placement in vm.placements track by placement.id"><td><a ui-sref="placement-detail({id:placement.id})">{{placement.id}}</a></td><td>{{placement.title}}</td><td>{{placement.description}}</td><td>{{placement.url}}</td><td><a ng-if="placement.image" ng-click="vm.openFile(placement.imageContentType, placement.image)"><img data-ng-src="{{\'data:\' + placement.imageContentType + \';base64,\' + placement.image}}" style="max-height: 30px"> </a><span ng-if="placement.image">{{placement.imageContentType}}, {{vm.byteSize(placement.image)}}</span></td><td><a ui-sref="artist-detail({id:placement.artistId})">{{placement.artistId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="placement-detail({id:placement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="placement.edit({id:placement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="placement.delete({id:placement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/price-inquiry/price-inquiries.html','<div><h3>Daten exportieren (Email)</h3><form name="priceInquiryExportForm" role="form" novalidate ng-submit="vm.exportPriceInquiries()"><div class="form-group"><label class="control-label" for="field_from">Von</label><div class="input-group"><input id="field_from" type="text" class="form-control" name="from" ng-click="vm.openCalendar(\'from\')" datetime-picker="dd.MM.yyyy" enable-time="false" ng-model="vm.from" is-open="vm.datePickerOpenStatus.from"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'from\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_to">Bis</label><div class="input-group"><input id="field_to" type="text" class="form-control" name="to" ng-click="vm.openCalendar(\'to\')" datetime-picker="dd.MM.yyyy" enable-time="false" ng-model="vm.to" is-open="vm.datePickerOpenStatus.to"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'to\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button type="submit" ng-disabled="vm.isExporting" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Download</span></button></form><hr><h3>Preisanfragen</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="submissionDate"><span>Datum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="event"><span>K\xFCnstler</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="organizationName"><span>Name der Schule</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="organizerName"><span>Name des Anfragenden</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="organizerEmail"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span>Fragen</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="priceInquiry in vm.priceInquiries track by priceInquiry.id"><td>{{priceInquiry.submissionDate | date:\'dd.MM.yyyy HH:mm\'}}</td><td>{{priceInquiry.artistTitle}}</td><td>{{priceInquiry.organizationName}}</td><td>{{priceInquiry.organizerName}}</td><td>{{priceInquiry.organizerEmail}}</td><td>{{priceInquiry.comment}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="price-inquiry.delete({id:priceInquiry.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/price-inquiry/price-inquiry-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.priceInquiry.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diese Preisanfrage wirklich l\xF6schen?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/price-inquiry/price-inquiry-detail.html','<div><h2><span>Preisanfrage</span> {{vm.priceInquiry.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name der Schule</span></dt><dd><span>{{vm.priceInquiry.organizationName}}</span></dd><dt><span>Name des Anfragenden</span></dt><dd><span>{{vm.priceInquiry.organizerName}}</span></dd><dt><span>Email Adresse</span></dt><dd><span>{{vm.priceInquiry.organizerEmail}}</span></dd><dt><span>Kommentar</span></dt><dd><span>{{vm.priceInquiry.comment}}</span></dd><dt><span>Datum</span></dt><dd><span>{{vm.priceInquiry.submissionDate | date:\'EEEE, dd.MM.yyyy HH:mm\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="price-inquiry-detail.edit({id:vm.priceInquiry.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/price-inquiry/price-inquiry-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPriceInquiryLabel">Create or edit a Price Inquiry</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.priceInquiry.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.priceInquiry.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_organizationName">Organization Name</label><input type="text" class="form-control" name="organizationName" id="field_organizationName" ng-model="vm.priceInquiry.organizationName" required><div ng-show="editForm.organizationName.$invalid"><p class="help-block" ng-show="editForm.organizationName.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_organizerName">Organizer Name</label><input type="text" class="form-control" name="organizerName" id="field_organizerName" ng-model="vm.priceInquiry.organizerName" required><div ng-show="editForm.organizerName.$invalid"><p class="help-block" ng-show="editForm.organizerName.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_organizerEmail">Organizer Email</label><input type="text" class="form-control" name="organizerEmail" id="field_organizerEmail" ng-model="vm.priceInquiry.organizerEmail" required><div ng-show="editForm.organizerEmail.$invalid"><p class="help-block" ng-show="editForm.organizerEmail.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.priceInquiry.comment"></div><div class="form-group"><label class="control-label" for="field_submissionDate">Submission Date</label><div class="input-group"><input id="field_submissionDate" type="text" class="form-control" name="submissionDate" datetime-picker="{{dateformat}}" ng-model="vm.priceInquiry.submissionDate" is-open="vm.datePickerOpenStatus.submissionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'submissionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_event">Event</label><select class="form-control" id="field_event" name="event" ng-model="vm.priceInquiry.eventId" ng-options="event.id as event.id for event in vm.events"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/reservation/reservation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reservation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diese Reservierung wirklich l\xF6schen?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/reservation/reservation-detail.html','<div><h2><span>Reservierung von</span> {{vm.reservation.organizationName}} ({{vm.reservation.submissionDate | date:\'yyyy-MM-dd\'}})</h2><hr><dl class="dl-horizontal jh-entity-details"><dt><span>Datum</span></dt><dd><span>{{vm.reservation.submissionDate | date:\'EEEE, dd.MM.yyyy HH:mm\'}}</span></dd><dt><span>Gebuchter Autor</span></dt><dd><span>{{vm.reservation.artistTitle}}</span></dd><dt><span>Gebuchte Veranstaltung</span></dt><dd><span>{{vm.reservation.eventTitle}}</span></dd><dt><span>Name der Schule</span></dt><dd><span>{{vm.reservation.organizationName}}</span></dd><dt><span>Adresse der Schule</span></dt><dd><span>{{vm.reservation.organizationAddress}}</span></dd><dt><span>Tel. der Schule</span></dt><dd><span>{{vm.reservation.organizationPhone}}</span></dd><dt><span>Name des Verantwortlichen</span></dt><dd><span>{{vm.reservation.organizerName}}</span></dd><dt><span>Private Tel.</span></dt><dd><span>{{vm.reservation.organizerPhone}}</span></dd><dt><span>Private Email</span></dt><dd><span>{{vm.reservation.organizerEmail}}</span></dd><dt><span>Wunschtermin</span></dt><dd><span>{{vm.reservation.desiredDate | date:\'EEEE, dd.MM.yyyy\'}}</span></dd><dt><span>Ersatztermin</span></dt><dd><span>{{vm.reservation.alternateDate | date:\'EEEE, dd.MM.yyyy\'}}</span></dd><dt><span>Unterrichtsbeginn</span></dt><dd><span>{{vm.reservation.lessonStart | date:\'HH:mm\'}}</span></dd><dt><span>Beginn gro\xDFe Pause</span></dt><dd><span>{{vm.reservation.breakFrom | date:\'HH:mm\'}}</span></dd><dt><span>Ende gro\xDFe Pause</span></dt><dd><span>{{vm.reservation.breakTo | date:\'HH:mm\'}}</span></dd><dt><span>Gesamtteilnehmerzahl</span></dt><dd><span>{{vm.reservation.numberOfAttendees}}</span></dd><dt><span>Alter der Sch\xFCler / Schulstufe</span></dt><dd><span>{{vm.reservation.attendeeDescription}}</span></dd><dt><span>Anzahl Veranstaltungen</span></dt><dd><span>{{vm.reservation.numberOfEvents}}</span></dd><dt><span>Fragen</span></dt><dd><span>{{vm.reservation.comment}}</span></dd><dt><span>Best\xE4tigung gemailt</span></dt><dd><span>{{vm.reservation.confirmationMailed | checkmark}}</span></dd><dt><span>Best\xE4tigung erhalten</span></dt><dd><span>{{vm.reservation.confirmationReceived | checkmark}}</span></dd><dt><span>Best\xE4tigung an K\xFCnstler</span></dt><dd><span>{{vm.reservation.confirmationMailedToAuthor | checkmark}}</span></dd><dt><span>Notiz</span></dt><dd><span>{{vm.reservation.note}}</span></dd><div ng-if="vm.accommodationSuggestion!=null"><dt><span>Quartier - Name</span></dt><dd><span>{{vm.accommodationSuggestion.name}}</span></dd><dt><span>Quartier - Email</span></dt><dd><span>{{vm.accommodationSuggestion.email}}</span></dd><dt><span>Quartier - Telefon</span></dt><dd><span>{{vm.accommodationSuggestion.phone}}</span></dd><dt><span>Quartier - Anmerkungen</span></dt><dd><span>{{vm.accommodationSuggestion.comment}}</span></dd></div></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="reservation-detail.edit({id:vm.reservation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Bearbeiten</span></button></div>');
$templateCache.put('app/entities/reservation/reservation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReservationLabel">Reservierung erstellen oder bearbeiten</h4></div><div class="modal-body"><!--<jhi-alert-error></jhi-alert-error>--><!--<div class="form-group" ng-show="vm.reservation.id">--><!--<label for="id">ID</label>--><!--<input type="text" class="form-control" id="id" name="id"--><!--ng-model="vm.reservation.id" readonly />--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_organizationName">Organization Name</label>--><!--<input type="text" class="form-control" name="organizationName" id="field_organizationName"--><!--ng-model="vm.reservation.organizationName"--><!--required />--><!--<div ng-show="editForm.organizationName.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.organizationName.$error.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_organizationAddress">Organization Address</label>--><!--<input type="text" class="form-control" name="organizationAddress" id="field_organizationAddress"--><!--ng-model="vm.reservation.organizationAddress"--><!--required />--><!--<div ng-show="editForm.organizationAddress.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.organizationAddress.$error.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_organizationPhone">Organization Phone</label>--><!--<input type="text" class="form-control" name="organizationPhone" id="field_organizationPhone"--><!--ng-model="vm.reservation.organizationPhone"--><!--required />--><!--<div ng-show="editForm.organizationPhone.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.organizationPhone.$error.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_organizerName">Organizer Name</label>--><!--<input type="text" class="form-control" name="organizerName" id="field_organizerName"--><!--ng-model="vm.reservation.organizerName"--><!--required />--><!--<div ng-show="editForm.organizerName.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.organizerName.$error.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_organizerPhone">Organizer Phone</label>--><!--<input type="text" class="form-control" name="organizerPhone" id="field_organizerPhone"--><!--ng-model="vm.reservation.organizerPhone"--><!--required />--><!--<div ng-show="editForm.organizerPhone.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.organizerPhone.$error.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_organizerEmail">Organizer Email</label>--><!--<input type="text" class="form-control" name="organizerEmail" id="field_organizerEmail"--><!--ng-model="vm.reservation.organizerEmail"--><!--required />--><!--<div ng-show="editForm.organizerEmail.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.organizerEmail.$error.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_desiredDate">Desired Date</label>--><!--<div class="input-group">--><!--<input id="field_desiredDate" type="text" class="form-control" name="desiredDate" datetime-picker="{{dateformat}}" ng-model="vm.reservation.desiredDate" is-open="vm.datePickerOpenStatus.desiredDate"--><!--/>--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'desiredDate\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_alternateDate">Alternate Date</label>--><!--<div class="input-group">--><!--<input id="field_alternateDate" type="text" class="form-control" name="alternateDate" datetime-picker="{{dateformat}}" ng-model="vm.reservation.alternateDate" is-open="vm.datePickerOpenStatus.alternateDate"--><!--/>--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'alternateDate\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_lessonStart">Lesson Start</label>--><!--<div class="input-group">--><!--<input id="field_lessonStart" type="text" class="form-control" name="lessonStart" datetime-picker="{{dateformat}}" ng-model="vm.reservation.lessonStart" is-open="vm.datePickerOpenStatus.lessonStart"--><!--required  />--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lessonStart\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--<div ng-show="editForm.lessonStart.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.lessonStart.$error.required">--><!--This field is required.--><!--</p>--><!--<p class="help-block"--><!--ng-show="editForm.lessonStart.$error.ZonedDateTimelocal">--><!--This field should be a date and time.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_breakFrom">Break From</label>--><!--<div class="input-group">--><!--<input id="field_breakFrom" type="text" class="form-control" name="breakFrom" datetime-picker="{{dateformat}}" ng-model="vm.reservation.breakFrom" is-open="vm.datePickerOpenStatus.breakFrom"--><!--required  />--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'breakFrom\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--<div ng-show="editForm.breakFrom.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.breakFrom.$error.required">--><!--This field is required.--><!--</p>--><!--<p class="help-block"--><!--ng-show="editForm.breakFrom.$error.ZonedDateTimelocal">--><!--This field should be a date and time.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_breakTo">Break To</label>--><!--<div class="input-group">--><!--<input id="field_breakTo" type="text" class="form-control" name="breakTo" datetime-picker="{{dateformat}}" ng-model="vm.reservation.breakTo" is-open="vm.datePickerOpenStatus.breakTo"--><!--required  />--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'breakTo\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--<div ng-show="editForm.breakTo.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.breakTo.$error.required">--><!--This field is required.--><!--</p>--><!--<p class="help-block"--><!--ng-show="editForm.breakTo.$error.ZonedDateTimelocal">--><!--This field should be a date and time.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_numberOfAttendees">Number Of Attendees</label>--><!--<input type="number" class="form-control" name="numberOfAttendees" id="field_numberOfAttendees"--><!--ng-model="vm.reservation.numberOfAttendees"--><!--required />--><!--<div ng-show="editForm.numberOfAttendees.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.numberOfAttendees.$error.required">--><!--This field is required.--><!--</p>--><!--<p class="help-block"--><!--ng-show="editForm.numberOfAttendees.$error.number">--><!--This field should be a number.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_attendeeDescription">Attendee Description</label>--><!--<input type="text" class="form-control" name="attendeeDescription" id="field_attendeeDescription"--><!--ng-model="vm.reservation.attendeeDescription"--><!--required />--><!--<div ng-show="editForm.attendeeDescription.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.attendeeDescription.$error.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_numberOfEvents">Number Of Events</label>--><!--<input type="number" class="form-control" name="numberOfEvents" id="field_numberOfEvents"--><!--ng-model="vm.reservation.numberOfEvents"--><!--required />--><!--<div ng-show="editForm.numberOfEvents.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.numberOfEvents.$error.required">--><!--This field is required.--><!--</p>--><!--<p class="help-block"--><!--ng-show="editForm.numberOfEvents.$error.number">--><!--This field should be a number.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_comment">Comment</label>--><!--<input type="text" class="form-control" name="comment" id="field_comment"--><!--ng-model="vm.reservation.comment"--><!--/>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="field_submissionDate">Submission Date</label>--><!--<div class="input-group">--><!--<input id="field_submissionDate" type="text" class="form-control" name="submissionDate" datetime-picker="{{dateformat}}" ng-model="vm.reservation.submissionDate" is-open="vm.datePickerOpenStatus.submissionDate"--><!--/>--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'submissionDate\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--</div>--><div class="form-group"><label class="control-label" for="field_confirmationMailed">Best\xE4tigung gemailt</label><input type="checkbox" class="form-control" name="confirmationMailed" id="field_confirmationMailed" ng-model="vm.reservation.confirmationMailed"></div><div class="form-group"><label class="control-label" for="field_confirmationReceived">Best\xE4tigung erhalten</label><input type="checkbox" class="form-control" name="confirmationReceived" id="field_confirmationReceived" ng-model="vm.reservation.confirmationReceived"></div><div class="form-group"><label class="control-label" for="field_confirmationMailedToAuthor">Best\xE4tigung an K\xFCnstler</label><input type="checkbox" class="form-control" name="confirmationMailedToAuthor" id="field_confirmationMailedToAuthor" ng-model="vm.reservation.confirmationMailedToAuthor"></div><div class="form-group"><label class="control-label" for="field_note">Notiz</label><input type="text" class="form-control" name="note" id="field_note" ng-model="vm.reservation.note"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/reservation/reservations.html','<div><h3>Daten exportieren (Name, Schule, Adresse, Email)</h3><form name="reservationExportForm" role="form" novalidate ng-submit="vm.exportReservations()"><div class="form-group"><label class="control-label" for="field_from">Von</label><div class="input-group"><input id="field_from" type="text" class="form-control" name="from" ng-click="vm.openCalendar(\'from\')" datetime-picker="dd.MM.yyyy" enable-time="false" ng-model="vm.from" is-open="vm.datePickerOpenStatus.from"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'from\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_to">Bis</label><div class="input-group"><input id="field_to" type="text" class="form-control" name="to" ng-click="vm.openCalendar(\'to\')" datetime-picker="dd.MM.yyyy" enable-time="false" ng-model="vm.to" is-open="vm.datePickerOpenStatus.to"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'to\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button type="submit" ng-disabled="vm.isExporting" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Download</span></button></form><hr><h3>Reservierungen</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="submissionDate"><span>Datum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="organizationName"><span>Organisator</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="event"><span>K\xFCnstler</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="confirmationMailed"><span>Best. gemailt</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="confirmationReceived"><span>Best. erhalten</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="confirmationMailedToAuthor"><span>Best. an K\xFCnstler</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="note"><span>Notiz</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="reservation in vm.reservations track by reservation.id"><td>{{reservation.submissionDate | date:\'dd.MM.yyyy HH:mm\'}}</td><td>{{reservation.organizationName}}</td><td>{{reservation.artistTitle}}</td><td>{{reservation.confirmationMailed | checkmark}}</td><td>{{reservation.confirmationReceived | checkmark}}</td><td>{{reservation.confirmationMailedToAuthor | checkmark}}</td><td>{{reservation.note}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reservation-detail({id:reservation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="reservation.edit({id:reservation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="reservation.delete({id:reservation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/static-page/static-page-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.staticPage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diese Seite wirklich l\xF6schen?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/static-page/static-page-detail.html','<div><h2><span>Static Page</span> {{vm.staticPage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Title</span></dt><dd><span>{{vm.staticPage.title}}</span></dd><dt><span>Content</span></dt><dd><div ng-bind-html="vm.staticPage.content | unsafe"></div></dd><dt><span>Position</span></dt><dd><span>{{vm.staticPage.position}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="static-page-detail.edit({id:vm.staticPage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Bearbeiten</span></button></div>');
$templateCache.put('app/entities/static-page/static-page-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStaticPageLabel">Seite erstellen oder bearbeiten</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_title">Titel</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.staticPage.title" required maxlength="255"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div><label>Seiteninhalt</label><textarea ui-tinymce="tinymceOptions" ng-model="vm.staticPage.content"></textarea></div><div class="form-group"><label class="control-label" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.staticPage.position"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/static-page/static-pages.html','<div><h2>Seiten</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="static-page.new"><span class="glyphicon glyphicon-plus"></span> <span>Neue Seite erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Titel</span></th><th><span>Position</span></th><th></th></tr></thead><tbody><tr ng-repeat="staticPage in vm.staticPages track by staticPage.id"><td>{{staticPage.title}}</td><td>{{staticPage.position}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="static-page-detail({id:staticPage.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="static-page.edit({id:staticPage.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="static-page.delete({id:staticPage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-8"><h1>Zugriff verweigert</h1><div class="alert alert-danger">Sie sind nicht berechtigt diese Seite zu sehen.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-8"><h1>Es ist leider ein Fehler aufgetreten.</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<!-- Navigation --><nav class="navbar navbar-default navbar-fixed-top" role="navigation"><div class="container"><!-- Brand and toggle get grouped for better mobile display --><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand" href="#"><img src="content/images/logo.png" alt=""></a></div><div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1" ng-class="{collapse:  vm.isNavbarCollapsed}" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="authors" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp;<span>Autoren</span></a></li><li ui-sref-active="active"><a ui-sref="hits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp;<span>Hits</span></a></li><!--<li ui-sref-active="active">--><!--<a ui-sref="home" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-home"></span>--><!--<span class="hidden-sm">Home</span>--><!--</a>--><!--</li>--><li ng-repeat="staticPage in vm.staticPages track by staticPage.id"><a ui-sref="info({url_id:staticPage.id})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp;<span>{{staticPage.title}}</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">Administration </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="artist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>K\xFCnstler</span></a></li><li ui-sref-active="active"><a ui-sref="reservation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Reservierungen</span></a></li><li ui-sref-active="active"><a ui-sref="price-inquiry" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Preisanfragen</span></a></li><li ui-sref-active="active"><a ui-sref="current-issue" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Aktuelles</span></a></li><li ui-sref-active="active"><a ui-sref="static-page" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Seiten</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" has-authority="ROLE_ADMIN">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!--<li ui-sref-active="active" ng-switch-when="true">--><!--<a ui-sref="settings" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-wrench"></span>&nbsp;--><!--<span>Einstellungen</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active" ng-switch-when="true">--><!--<a ui-sref="password" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-lock"></span>&nbsp;--><!--<span>Passwort</span>--><!--</a>--><!--</li>--><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Abmelden</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Intern</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-wrench"></span> <span class="hidden-sm">Service</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span>Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span>Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span>Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span>Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span>Database</span></a></li></ul></li></ul></div><!-- /.navbar-collapse --></div><!-- /.container --></nav><!--\n<nav class="navbar navbar-default" role="navigation">\n    <div class="container">\n        <div class="navbar-header">\n            <button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()">\n                <span class="sr-only">Toggle navigation</span>\n                <span class="icon-bar"></span>\n                <span class="icon-bar"></span>\n                <span class="icon-bar"></span>\n            </button>\n            <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()">\n                <img class="logo-img" src="content/images/logo-jhipster.png"/>\n                <span>Autorenlesung</span> <span class="navbar-version">v{{VERSION}}</span>\n            </a>\n        </div>\n        <div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()">\n            <ul class="nav navbar-nav navbar-right">\n\n            </ul>\n        </div>\n    </div>\n</nav>\n-->');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');}]);})();